import { toast } from "react-toastify";
import { deleteItems, updateStateData } from "../Store/actions";
import store from "../Store/store";
import { createCookie, deleteCookie, sendApiRequest, setBatchLoadingStatus } from "./requestConfig";
import { LISTING_RELOAD, withListingReload } from "./listingReload";
import {
  allNumbersBetweenRange,
  validateAlphabets,
  validateAlphanumeric,
  validateEmpty,
  validateNegativeDecimalNumbers,
  validateNumbers,
  WEEKDAY_KEYS,
  WEEKDAY_LOWER_TO_INT,
  WEEKDAY_INT_TO_LOWER,
} from "./utils";
import { checkUserDetailsFromCookie } from "./userManagement";
import { rootRetailerOptionFields } from "../components/commonComponents/Filters/storeFilterUtils";
import {
  clearStagedOwnerOutsideRetailerNotice,
  showStagedOwnerOutsideRetailerNotice,
  stageOwnerOutsideRetailerNotice,
} from "../components/commonComponents/Hoc/accessControlToasts";

let mappingOffsets = {
  ANT1: [
    "ANT1: MULTIPLEXER OUT1",
    "ANT1: MULTIPLEXER OUT2",
    "ANT1: MULTIPLEXER OUT3",
    "ANT1: MULTIPLEXER OUT4",
    "ANT1: MULTIPLEXER OUT5",
    "ANT1: MULTIPLEXER OUT6",
    "ANT1: MULTIPLEXER OUT7",
    "ANT1: MULTIPLEXER OUT8",
  ],
  ANT2: [
    "ANT2: MULTIPLEXER OUT1",
    "ANT2: MULTIPLEXER OUT2",
    "ANT2: MULTIPLEXER OUT3",
    "ANT2: MULTIPLEXER OUT4",
    "ANT2: MULTIPLEXER OUT5",
    "ANT2: MULTIPLEXER OUT6",
    "ANT2: MULTIPLEXER OUT7",
    "ANT2: MULTIPLEXER OUT8",
  ],
  ANT3: [
    "ANT3: MULTIPLEXER OUT1",
    "ANT3: MULTIPLEXER OUT2",
    "ANT3: MULTIPLEXER OUT3",
    "ANT3: MULTIPLEXER OUT4",
    "ANT3: MULTIPLEXER OUT5",
    "ANT3: MULTIPLEXER OUT6",
    "ANT3: MULTIPLEXER OUT7",
    "ANT3: MULTIPLEXER OUT8",
  ],
  ANT4: [
    "ANT4: MULTIPLEXER OUT1",
    "ANT4: MULTIPLEXER OUT2",
    "ANT4: MULTIPLEXER OUT3",
    "ANT4: MULTIPLEXER OUT4",
    "ANT4: MULTIPLEXER OUT5",
    "ANT4: MULTIPLEXER OUT6",
    "ANT4: MULTIPLEXER OUT7",
    "ANT4: MULTIPLEXER OUT8",
  ],
  "No Multiplexer": [],
};

let mappingOffsetPositions = {
  "ANT1": 1,
  "ANT2": 2,
  "ANT3": 3,
  "ANT4": 4,
  "ANT1: MULTIPLEXER OUT1": 5,
  "ANT1: MULTIPLEXER OUT2": 6,
  "ANT1: MULTIPLEXER OUT3": 7,
  "ANT1: MULTIPLEXER OUT4": 8,
  "ANT1: MULTIPLEXER OUT5": 9,
  "ANT1: MULTIPLEXER OUT6": 10,
  "ANT1: MULTIPLEXER OUT7": 11,
  "ANT1: MULTIPLEXER OUT8": 12,
  "ANT2: MULTIPLEXER OUT1": 13,
  "ANT2: MULTIPLEXER OUT2": 14,
  "ANT2: MULTIPLEXER OUT3": 15,
  "ANT2: MULTIPLEXER OUT4": 16,
  "ANT2: MULTIPLEXER OUT5": 17,
  "ANT2: MULTIPLEXER OUT6": 18,
  "ANT2: MULTIPLEXER OUT7": 19,
  "ANT2: MULTIPLEXER OUT8": 20,
  "ANT3: MULTIPLEXER OUT1": 21,
  "ANT3: MULTIPLEXER OUT2": 22,
  "ANT3: MULTIPLEXER OUT3": 23,
  "ANT3: MULTIPLEXER OUT4": 24,
  "ANT3: MULTIPLEXER OUT5": 25,
  "ANT3: MULTIPLEXER OUT6": 26,
  "ANT3: MULTIPLEXER OUT7": 27,
  "ANT3: MULTIPLEXER OUT8": 28,
  "ANT4: MULTIPLEXER OUT1": 29,
  "ANT4: MULTIPLEXER OUT2": 30,
  "ANT4: MULTIPLEXER OUT3": 31,
  "ANT4: MULTIPLEXER OUT4": 32,
  "ANT4: MULTIPLEXER OUT5": 33,
  "ANT4: MULTIPLEXER OUT6": 34,
  "ANT4: MULTIPLEXER OUT7": 35,
  "ANT4: MULTIPLEXER OUT8": 36,
};

// track changes across different tabs, and show notification if user leaves a section without saving the details
export const trackChanges = (trackFlag) => {
  store.dispatch(
    updateStateData({
      track_infra_changes: trackFlag,
    })
  );
};

// to sort store locations
export const sortStoreLocations = (sortingParam, sortingMeasure) => {
  const userStateData = store.getState().userSelections;
  const sortedList =
    typeof userStateData.infra_store_locs !== "undefined" && userStateData.infra_store_locs.length !== 0
      ? userStateData.infra_store_locs.slice().sort((a, b) => {
        if (sortingParam.cyreenId === true) {
          const splittedIp_A = typeof a.store_ip !== "undefined" ? a.store_ip : "0.0.0.0";
          const splittedIp_B = typeof b.store_ip !== "undefined" ? b.store_ip : "0.0.0.0";
          const num1 = Number(splittedIp_A.split(".").slice(0, -1).map((num) => (`000${num}`).slice(-3)).join(""));
          const num2 = Number(splittedIp_B.split(".").slice(0, -1).map((num) => (`000${num}`).slice(-3)).join(""));

          return sortingMeasure.cyreenId === "asc"
            ? num1 - num2
            : num2 - num1;
        } else {
          return sortingMeasure.store_name === "asc" ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name);
        }
      })
      : [];

  store.dispatch(
    updateStateData({
      ...userStateData,
      infra_store_locs: sortedList,
    })
  );
};

export const sortExcelStoreLocations = (sortingParam, sortingMeasure, storeRLocecords) => {
  const sortedList =
    typeof storeRLocecords !== "undefined" && storeRLocecords.length !== 0
      ? storeRLocecords.slice().sort((a, b) => {
        if (sortingParam.cyreenId === true) {
          return sortingMeasure.cyreenId === "asc"
            ? a.number_store_cyreen - b.number_store_cyreen
            : b.number_store_cyreen - a.number_store_cyreen;
        } else {
          return sortingMeasure.store_name === "asc" ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name);
        }
      })
      : [];

  return sortedList;
};

// save/update pictures pagination info in cookies
export const manageStoresPaginationCookie = (storePaginationObj) => {
  const currentStateData = store.getState().userSelections;
  //
  const paginationObj = typeof currentStateData.stores_pagination !== "undefined" ? currentStateData.stores_pagination : {};

  store.dispatch(updateStateData({ stores_pagination: { ...paginationObj, ...storePaginationObj } }));

  deleteCookie("stores_pagination");
  // set cookie for pagination
  createCookie("stores_pagination", JSON.stringify({ ...paginationObj, ...storePaginationObj }));
}

// Fetch paginated store rows for the Infrastructure listing (and other usedFor callers).
export const fetchStoreLocations = async (pageNumber, pageSize, usedFor = "list") => {
  // Only the stores listing page should show table Loading… — modal fetches use usedFor !== "list".
  if (usedFor === "list") {
    return withListingReload(LISTING_RELOAD.stores, () => fetchStoreLocationsPage(pageNumber, pageSize, usedFor));
  }
  return fetchStoreLocationsPage(pageNumber, pageSize, usedFor);
};

const fetchStoreLocationsPage = async (pageNumber, pageSize, usedFor = "list") => {
  const currentStateData = store.getState().userSelections;
  // check if page number and page size are passed from the component, if not then set default values.
  if (typeof pageNumber === "undefined" && typeof pageSize === "undefined") {
    pageNumber = 0;
    pageSize = 10;
    // page number/size from the cookies if available
    if (typeof currentStateData.stores_pagination !== "undefined") {
      pageNumber = currentStateData.stores_pagination.pageNumber;
      pageSize = currentStateData.stores_pagination.pageSize;
    }
  }
  let storesListApiEndpoint = "stores?page=" + pageNumber + "&size=" + pageSize;

  // apply sorting if available
  if (typeof currentStateData.infra_sorting_measure !== "undefined" && currentStateData.infra_sorting_measure.sortField !== "" && currentStateData.infra_sorting_measure.sortOrder !== "") {
    let sortField = currentStateData.infra_sorting_measure.sortField;
    let sortOrder = currentStateData.infra_sorting_measure.sortOrder;

    storesListApiEndpoint = storesListApiEndpoint + "&sortBy=" + sortField + "&sortDir=" + sortOrder;
  } else {
    storesListApiEndpoint = storesListApiEndpoint + "&sortBy=ipAddress&sortDir=asc";
  }

  // check if filters are applied, then we need to fetch the filtered list.
  if (
    typeof currentStateData.store_list_filters !== "undefined" && currentStateData.store_list_filter_applied === true
  ) {
    // ip filter
    if (
      typeof currentStateData.store_list_filters.ip_filter !== "undefined" &&
      currentStateData.store_list_filters.ip_filter.length !== 0
    ) {
      currentStateData.store_list_filters.ip_filter.forEach((item) => {
        storesListApiEndpoint = storesListApiEndpoint + "&ip_address=" + item;
      });
    }

    // pic name filter
    if (
      typeof currentStateData.store_list_filters.store_name !== "undefined" &&
      currentStateData.store_list_filters.store_name.length !== 0
    ) {
      currentStateData.store_list_filters.store_name.forEach((item) => {
        storesListApiEndpoint = storesListApiEndpoint + "&store_id=" + item;
      });
    }
    // retailer/owner filter
    if (
      typeof currentStateData.store_list_filters.store_company_filter !== "undefined" &&
      currentStateData.store_list_filters.store_company_filter.length !== 0
    ) {
      currentStateData.store_list_filters.store_company_filter.forEach((item) => {
        storesListApiEndpoint = storesListApiEndpoint + "&id_company=" + item;
      });
    }
    // Root retailer filter (UI label "Retailer"; Redux key root_retailer_filter)
    if (
      typeof currentStateData.store_list_filters.root_retailer_filter !== "undefined" &&
      currentStateData.store_list_filters.root_retailer_filter.length !== 0
    ) {
      currentStateData.store_list_filters.root_retailer_filter.forEach((item) => {
        storesListApiEndpoint = storesListApiEndpoint + "&retailer=" + item;
      });
    }
    // status filter
    if (
      typeof currentStateData.store_list_filters.status_filter !== "undefined" &&
      currentStateData.store_list_filters.status_filter.length !== 0
    ) {
      storesListApiEndpoint = storesListApiEndpoint + "&status=" + currentStateData.store_list_filters.status_filter;
      // currentStateData.store_list_filters.status_filter.forEach((item) => {
      //   storesListApiEndpoint = storesListApiEndpoint + "&status=" + item;
      // });
    }
  }

  const fetchStoreLoc = await sendApiRequest(storesListApiEndpoint, {}, "GET");
  //   evaluate api response
  if (typeof fetchStoreLoc.success !== "undefined" && fetchStoreLoc.success === true) {
    if (usedFor === "list") {
      store.dispatch(
        updateStateData({
          infra_store_locs:
            typeof fetchStoreLoc.response !== "undefined" && fetchStoreLoc.response.content.length !== 0
              ? fetchStoreLoc.response.content
              : [],
        })
      );

      // save/update campaign pagination info
      manageStoresPaginationCookie({
        totalPages: fetchStoreLoc.response.totalPages,
        totalRecords: fetchStoreLoc.response.totalElements,
        pageNumber: fetchStoreLoc.response.number,
        pageSize: fetchStoreLoc.response.size,
      });

      // scroll to the top of page
      window.scrollTo(0, 0);

      return {
        success: true,
      };
    } else {
      return {
        success: true,
        store_location_list: fetchStoreLoc.response.content,
      };
    }

  } else {
    toast("Sorry, something went wrong", { type: "error" });
    return {
      success: false,
    };
  }
};

// Root retailer companies for the store locations listing filter drawer.
export const fetchStoreRetailerFilterOptions = async () => {
  const retailerList = await sendApiRequest("dropdowns/filters/stores/retailers", {}, "GET");

  if (typeof retailerList.success === "undefined" || retailerList.success !== true) {
    return { success: false };
  }

  const rows = Array.isArray(retailerList.response)
    ? retailerList.response
    : Array.isArray(retailerList.response?.value)
      ? retailerList.response.value
      : [];

  store.dispatch(
    updateStateData({
      store_list_retailer_filter_info: rows.map((retailer) => ({
        id: retailer.id,
        label: retailer.name,
      })),
    })
  );

  return { success: true };
};

export const fetchStoreNames = async () => {
  const StoreList = await sendApiRequest("stores/list", {}, "GET");
  if (typeof StoreList.success !== "undefined" && StoreList.success === true) {
    let storeNamesList = [];
    StoreList.response.forEach((store) => {
      // id, label, and cyreen_id stay so drawers still save store ids.
      // Root retailer is only used when the Stores field is grouped.
      storeNamesList.push({
        id: store.id,
        label: store.name,
        cyreen_id: store.number_store_cyreen,
        ...rootRetailerOptionFields(store),
      });
    });

    store.dispatch(
      updateStateData({
        store_names_info: {
          store_names_list: storeNamesList,
        },
        store_list_response_for_filters: StoreList.response,
      })
    );

    return {
      success: true,
    };
  } else {
    return {
      success: false,
    };
  }
};

// fetch store IPs for filter dropdown
export const fetchIpAddressForFilter = async () => {
  const ipList = await sendApiRequest("stores/ip-list", {}, "GET");
  if (typeof ipList.success !== "undefined" && ipList.success === true) {
    let ipFilterList = [];
    ipList.response.forEach((ipAddress) => {
      ipFilterList.push({ label: ipAddress, value: ipAddress });
    });

    store.dispatch(
      updateStateData({
        store_ip_list: ipFilterList,
      })
    );

    return {
      success: true,
    };
  } else {
    return {
      success: false,
    };
  }
};

// to fetch opening hours
export const fetchOpeningHours = async () => {
  const fetchHours = await sendApiRequest("stores/opening-hours", {}, "GET");
  //evaluate api response
  if (typeof fetchHours.success !== "undefined" && fetchHours.success === true) {
    store.dispatch(
      updateStateData({
        infra_opening_hours: fetchHours.response.map((openHour) => {
          return {
            id: openHour.id,
            description: openHour.description,
            ...openHour,
          };
        }),
      })
    );

    return {
      success: true,
    };
  } else {
    toast("Sorry, something went wrong", { type: "error" });
    return {
      success: false,
    };
  }
};

// fetch opening hour id
export const fetchOpeningHourId = (selectedHourDesc) => {
  const userStateData = store.getState().userSelections;
  let hourId = "";
  let weekDayHours = {};
  let selectedWeekDays = {};

  if (
    selectedHourDesc !== "" &&
    typeof userStateData.infra_opening_hours !== "undefined" &&
    userStateData.infra_opening_hours.length !== 0
  ) {
    let openingHourList = userStateData.infra_opening_hours;
    if (typeof userStateData.custom_opening_hour !== "undefined") {
      openingHourList = [...openingHourList, userStateData.custom_opening_hour];
    }
    openingHourList.forEach((hourDetail) => {
      if (selectedHourDesc === hourDetail.description) {
        hourId = hourDetail.id;
        weekDayHours = {
          monday: hourDetail.monday,
          tuesday: hourDetail.tuesday,
          wednesday: hourDetail.wednesday,
          thursday: hourDetail.thursday,
          friday: hourDetail.friday,
          saturday: hourDetail.saturday,
          sunday: hourDetail.sunday,
        };
        selectedWeekDays = {
          monday: hourDetail.monday[0] === "00:00" && hourDetail.monday[1] === "00:00" ? false : true,
          tuesday: hourDetail.tuesday[0] === "00:00" && hourDetail.tuesday[1] === "00:00" ? false : true,
          wednesday: hourDetail.wednesday[0] === "00:00" && hourDetail.wednesday[1] === "00:00" ? false : true,
          thursday: hourDetail.thursday[0] === "00:00" && hourDetail.thursday[1] === "00:00" ? false : true,
          friday: hourDetail.friday[0] === "00:00" && hourDetail.friday[1] === "00:00" ? false : true,
          saturday: hourDetail.saturday[0] === "00:00" && hourDetail.saturday[1] === "00:00" ? false : true,
          sunday: hourDetail.sunday[0] === "00:00" && hourDetail.sunday[1] === "00:00" ? false : true,
        };
      }
    });
  }
  return {
    hourId,
    weekDayHours,
    selectedWeekDays,
    selected_default_hours:
      typeof weekDayHours.monday !== "undefined" ? [weekDayHours.monday[0], weekDayHours.monday[1]] : ["00:00", "00:00"],
  };
};

// fetch region id
export const fetchRegionId = (selectedRegion) => {
  const userStateData = store.getState().userSelections;
  let regionId = {};
  if (
    selectedRegion !== "" &&
    typeof userStateData.regions_list !== "undefined" &&
    userStateData.regions_list.length !== 0
  ) {
    userStateData.regions_list.forEach((regionDetail) => {
      if (selectedRegion === regionDetail.label) {
        regionId = regionDetail;
      }
    });
  }
  return regionId;
};

// fetch country id
export const fetchCountryId = (selectedCountry) => {
  const userStateData = store.getState().userSelections;
  let countryId = "";
  if (
    selectedCountry !== "" &&
    typeof userStateData.countries_list !== "undefined" &&
    userStateData.countries_list.length !== 0
  ) {
    userStateData.countries_list.forEach((countryDetail) => {
      if (selectedCountry === countryDetail.name) {
        countryId = countryDetail.id;
      }
    });
  }
  return countryId;
};

// End-of-day sentinel: 00:00 means "until midnight" (backend stores as 23:59).
export const END_OF_DAY_VALUES = ["00:00"];

export const isEndOfDay = (timeStr) => END_OF_DAY_VALUES.includes(timeStr);

// Normalize a close time used in comparisons / payloads: end-of-day picks map
// to 23:59 so that constraints (overlap, end-after-start) treat them as midnight.
export const normalizeCloseTime = (closeTime) =>
  isEndOfDay(closeTime) ? "23:59" : closeTime;

// Inverse of normalizeCloseTime: API stores end-of-day as 23:59, UI shows 00:00.
export const denormalizeCloseTime = (closeTime) =>
  closeTime === "23:59" ? "00:00" : closeTime;

// Returns true when the close time is strictly before (or equal to) the open
// time and is NOT one of the end-of-day sentinels. Used for live "End must be
// after Start" feedback in the schedule editor.
export const isInvertedRange = (openTime, closeTime) => {
  if (!openTime || !closeTime) return false;
  if (isEndOfDay(closeTime)) return false;
  return closeTime <= openTime;
};

// Cyreen and tenant pick from the company tree. Branch picks from the flat share-list.
// Agency, retailer, and brand are saved under their assigned company.
const STORE_OWNER_PICKER_USER_TYPES = ["cyreen", "tenant", "branch"];

const storeOwnerIdForSave = (loggedUserDetails, currentStateData) => {
  const rawType = loggedUserDetails?.user_detail?.user_type;
  const userType = typeof rawType === "string" ? rawType.toLowerCase() : "";
  if (STORE_OWNER_PICKER_USER_TYPES.includes(userType)) {
    const selectedId = currentStateData?.new_store_loc_data?.share_list;
    return typeof selectedId !== "undefined" && selectedId !== null ? selectedId : "";
  }
  if (
    loggedUserDetails?.success === true &&
    typeof loggedUserDetails.user_detail?.assigned_company !== "undefined"
  ) {
    return loggedUserDetails.user_detail.assigned_company.id;
  }
  return "";
};

// validate store loc data
const validateStoreLocData = (schedules = []) => {
  const currentStateData = store.getState().userSelections;
  const loggedUserDetails = checkUserDetailsFromCookie();
  const storeId =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.id !== "undefined"
      ? currentStateData.new_store_loc_data.id
      : "";
  const storeName =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.store_name !== "undefined"
      ? currentStateData.new_store_loc_data.store_name
      : "";
  const storeCountry =
    typeof loggedUserDetails.success !== "undefined" && loggedUserDetails.success === true
      ? loggedUserDetails.user_detail.current_workspace.country.name
      : "";
  const storeCountryId =
    typeof loggedUserDetails.success !== "undefined" && loggedUserDetails.success === true
      ? loggedUserDetails.user_detail.current_workspace.country.id
      : "";
  // typeof currentStateData.new_store_loc_data !== "undefined" &&
  // typeof currentStateData.new_store_loc_data.store_country !== "undefined"
  //   ? currentStateData.new_store_loc_data.store_country
  //   : "";
  const storeRegion =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.store_region !== "undefined"
      ? currentStateData.new_store_loc_data.store_region
      : "";
  const newRegion =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.new_region !== "undefined"
      ? currentStateData.new_store_loc_data.new_region
      : false;
  const newRegionName =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.new_region_name !== "undefined"
      ? currentStateData.new_store_loc_data.new_region_name
      : "";
  const newRegionCode =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.new_region_code !== "undefined"
      ? currentStateData.new_store_loc_data.new_region_code
      : "";
  const storeStreet =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.store_street !== "undefined"
      ? currentStateData.new_store_loc_data.store_street
      : "";
  const storeZip =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.store_zip !== "undefined"
      ? currentStateData.new_store_loc_data.store_zip
      : "";
  const storeCity =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.store_city !== "undefined"
      ? currentStateData.new_store_loc_data.store_city
      : "";
  const longitude =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.longitude !== "undefined"
      ? currentStateData.new_store_loc_data.longitude
      : "";
  const latitude =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.latitude !== "undefined"
      ? currentStateData.new_store_loc_data.latitude
      : "";
  const retailerStoreId =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.retailer_store_id !== "undefined"
      ? currentStateData.new_store_loc_data.retailer_store_id
      : "";
  const storeTrolleys =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.store_trolleys !== "undefined"
      ? currentStateData.new_store_loc_data.store_trolleys
      : "";

  const storeBaskets =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.store_baskets !== "undefined"
      ? currentStateData.new_store_loc_data.store_baskets
      : "";
  const storeStatus =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.store_status !== "undefined"
      ? currentStateData.new_store_loc_data.store_status
      : "";
  const storeSize =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.store_size !== "undefined"
      ? currentStateData.new_store_loc_data.store_size
      : "";
  const automatedStores =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.automated_checkout !== "undefined"
      ? currentStateData.new_store_loc_data.automated_checkout
      : "Automated";

  const ownerValue = storeOwnerIdForSave(loggedUserDetails, currentStateData);

  const selectedTimezoneId = typeof currentStateData.new_store_loc_data !== "undefined" &&
    typeof currentStateData.new_store_loc_data.selected_timezone_id !== "undefined"
    ? currentStateData.new_store_loc_data.selected_timezone_id
    : "";

  let error = false;
  let errorMessages = {};

  // validate all the required fields
  // store name
  const validateStoreName = validateEmpty(storeName);
  if (validateStoreName.error === true) {
    error = true;
    errorMessages = {
      ...errorMessages,
      store_name: "Store name must not be empty",
    };
  }
  // country
  if (storeCountry === "") {
    error = true;
    errorMessages = {
      ...errorMessages,
      store_country: "Please select the country",
    };
  }
  // region
  if (storeRegion === "") {
    error = true;
    errorMessages = {
      ...errorMessages,
      store_region: "Please select the region",
    };
  }
  // if a new region to be added
  if (newRegion === true) {
    // validate details
    const validateRegionName = validateEmpty(newRegionName);
    const validateRegionCode = validateEmpty(newRegionCode);
    //
    if (validateRegionName.error === true) {
      error = true;
      errorMessages = {
        ...errorMessages,
        new_region_name: "Region name must not be empty and may not contain special characters",
      };
    } else {
      // check for duplicacy
      const existingRegionNames = currentStateData.regions_list.map((regionOption) => {
        return regionOption.label;
      });
      if (existingRegionNames.includes(newRegionName)) {
        error = true;
        errorMessages = {
          ...errorMessages,
          new_region_name: "Region name already exist",
        };
      }
    }
    // Region code
    if (validateRegionCode.error === true) {
      error = true;
      errorMessages = {
        ...errorMessages,
        new_region_code: "Region code must not be empty and may not contain special characters",
      };
    }
  }
  // street
  const validateStreet = validateEmpty(storeStreet);
  if (validateStreet.error === true) {
    error = true;
    errorMessages = {
      ...errorMessages,
      store_street: "Street & no. must not be empty",
    };
  }

  // zip
  const validateZip = validateEmpty(storeZip);
  if (validateZip.error === true) {
    error = true;
    errorMessages = {
      ...errorMessages,
      store_zip: "Zip code  must not be empty",
    };
  }

  // city
  const validateCity = validateEmpty(storeCity);
  if (validateCity.error === true) {
    error = true;
    errorMessages = {
      ...errorMessages,
      store_city: "City must not be empty",
    };
  }
  // longitude latitude
  const validateLongitude = validateNegativeDecimalNumbers(longitude, true);
  if (validateLongitude.error === true) {
    error = true;
    errorMessages = {
      ...errorMessages,
      longitude: "Longitude cannot be empty or contain letters. Use period as decimal separator",
    };
  }

  // city
  const validateLatitude = validateNegativeDecimalNumbers(latitude, true);
  if (validateLatitude.error === true) {
    error = true;
    errorMessages = {
      ...errorMessages,
      latitude: "Latitude cannot be empty or contain letters. Use period as decimal separator",
    };
  }
  // owner validation
  if (ownerValue === "") {
    error = true;
    errorMessages = {
      ...errorMessages,
      share_list_selection: "Please make a selection",
    };
  }

  // validate timezone
  if (selectedTimezoneId === "") {
    error = true;
    errorMessages = {
      ...errorMessages,
      selected_timezone: "Please select the timezone",
    };
  }
  // retailer store id
  if (retailerStoreId !== "" && retailerStoreId !== null) {
    const validateRetailerId = validateNumbers(retailerStoreId);
    if (validateRetailerId.error === true) {
      error = true;
      errorMessages = {
        ...errorMessages,
        retailer_store_id: "Retailer store id may not contain letters or negative values",
      };
    }
  }

  // storeTrolleys
  if (storeTrolleys !== "" && storeTrolleys !== null) {
    const validateTrolleys = validateNumbers(storeTrolleys);
    if (validateTrolleys.error === true) {
      error = true;
      errorMessages = {
        ...errorMessages,
        store_trolleys: "Equipped trolleys may not contain letters or negative values",
      };
    }
  }
  // storeBaskets
  if (storeBaskets !== "" && storeBaskets !== null) {
    const validateBaskets = validateNumbers(storeBaskets);
    if (validateBaskets.error === true) {
      error = true;
      errorMessages = {
        ...errorMessages,
        store_baskets: "Equipped baskets may not contain letters or negative values",
      };
    }
  }

  if (storeSize !== "" && storeSize !== null) {
    const validateStoreSize = validateNumbers(storeSize, true);
    if (validateStoreSize.error === true) {
      error = true;
      errorMessages = {
        ...errorMessages,
        store_size: "Store size must not be empty and may not contain letters or negative values",
      };
    }
  }

  // return error messages or the store data request body
  if (error === true) {
    toast("Please fill in valid information", { type: "error" });

    return {
      error: true,
      errorMessages,
    };
  } else {
    let storeLocRequestObj = {
      name: storeName,
      address: storeStreet,
      city: storeCity,
      zipCode: storeZip,
      region_id: currentStateData?.new_store_loc_data?.store_region_id,
      region: currentStateData?.new_store_loc_data?.store_region_obj,
      country_id: storeCountryId,
      installed_trolleys: storeTrolleys,
      installed_baskets: storeBaskets,
      store_size: storeSize,
      automated: automatedStores === "Automated" ? true : false,
      number_store_retailer: retailerStoreId,
      longitude: longitude,
      latitude: latitude,
      retailer_id: ownerValue,
      id_timezone: selectedTimezoneId,
      opening_hours_schedule: schedules.map((schedule) => {
        const scheduleMap = {};
        WEEKDAY_KEYS.forEach((day) => {
          const dayData = schedule.weekdays?.[day] || {};
          if (!dayData.open) {
            scheduleMap[String(WEEKDAY_LOWER_TO_INT[day])] = [];
            return;
          }
          if (schedule.same_times_all_days) {
            scheduleMap[String(WEEKDAY_LOWER_TO_INT[day])] = schedule.same_times_is_24h
              ? [{ start: "00:00", end: "23:59" }]
              : (schedule.same_times_ranges || []).map((r) => ({ start: r.open, end: normalizeCloseTime(r.close) }));
          } else if (dayData.is_24h) {
            scheduleMap[String(WEEKDAY_LOWER_TO_INT[day])] = [{ start: "00:00", end: "23:59" }];
          } else {
            scheduleMap[String(WEEKDAY_LOWER_TO_INT[day])] = (dayData.time_ranges || []).map((r) => ({ start: r.open, end: normalizeCloseTime(r.close) }));
          }
        });
        return {
          valid_from: schedule.validity_start,
          valid_to: schedule.no_end ? null : schedule.validity_end,
          name: schedule.name || "",
          schedule: scheduleMap,
          active: schedule.active !== false,
        };
      }),
    };

    // append store id (if we are updating the store location)
    if (storeId !== "") {
      const actualDeviceStatus = checkDeviceStatus();
      const activeStoreValue = storeStatus === "Active" ? true : false;
      storeLocRequestObj = {
        ...storeLocRequestObj,
        id: storeId,
      };
      if (actualDeviceStatus !== activeStoreValue) {
        storeLocRequestObj = {
          ...storeLocRequestObj,
          active: activeStoreValue,
        };
      }
    } else {
      storeLocRequestObj = {
        ...storeLocRequestObj,
        active: false,
      };
    }

    // update request body if new region has to be added
    if (currentStateData?.new_store_loc_data?.new_region === true) {
      storeLocRequestObj = {
        ...storeLocRequestObj,
        region: {
          name: newRegionName,
          code: newRegionCode,
          country: storeCountryId,
        },
      };
    }

    return {
      error: false,
      store_loc_request_data: storeLocRequestObj,
    };
  }
};

// save store location data
export const saveStoreLocData = async (usedFor, schedules = []) => {
  const validateStoreData = validateStoreLocData(schedules);

  if (validateStoreData.error === true) {
    return {
      success: false,
      errorMessages: validateStoreData.errorMessages,
    };
  } else {
    // Recorded before the request. The store form is cleared after a successful save.
    stageOwnerOutsideRetailerNotice(validateStoreData.store_loc_request_data.retailer_id, usedFor !== "update");
    const saveData = await sendApiRequest("stores/save", validateStoreData.store_loc_request_data, "POST");
    //evaluate api response
    if (typeof saveData.response.success !== "undefined" && saveData.response.success === true) {
      let message = usedFor === "update" ? "Store updated successfully." : "Store added successfully.";
      toast(message, { type: "success" });
      showStagedOwnerOutsideRetailerNotice();
      return {
        success: true,
        store_id: saveData.response.store_id,
      };
    } else {
      clearStagedOwnerOutsideRetailerNotice();
      toast(saveData.response.error_detail, { type: "error" });
      return {
        success: false,
      };
    }
  }
};

// ─── Step validators for the store creation/update wizard ───────────────────

// Validates Step 1 — General Information fields
export const validateStoreGeneralInfo = () => {
  const currentStateData = store.getState().userSelections;
  const loggedUserDetails = checkUserDetailsFromCookie();

  const storeName =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.store_name !== "undefined"
      ? currentStateData.new_store_loc_data.store_name
      : "";
  const storeCountry =
    typeof loggedUserDetails.success !== "undefined" && loggedUserDetails.success === true
      ? loggedUserDetails.user_detail.current_workspace.country.name
      : "";
  const storeRegion =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.store_region !== "undefined"
      ? currentStateData.new_store_loc_data.store_region
      : "";
  const newRegion =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.new_region !== "undefined"
      ? currentStateData.new_store_loc_data.new_region
      : false;
  const newRegionName =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.new_region_name !== "undefined"
      ? currentStateData.new_store_loc_data.new_region_name
      : "";
  const newRegionCode =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.new_region_code !== "undefined"
      ? currentStateData.new_store_loc_data.new_region_code
      : "";
  const storeStreet =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.store_street !== "undefined"
      ? currentStateData.new_store_loc_data.store_street
      : "";
  const storeZip =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.store_zip !== "undefined"
      ? currentStateData.new_store_loc_data.store_zip
      : "";
  const storeCity =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.store_city !== "undefined"
      ? currentStateData.new_store_loc_data.store_city
      : "";
  const longitude =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.longitude !== "undefined"
      ? currentStateData.new_store_loc_data.longitude
      : "";
  const latitude =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.latitude !== "undefined"
      ? currentStateData.new_store_loc_data.latitude
      : "";
  const selectedTimezoneId =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.selected_timezone_id !== "undefined"
      ? currentStateData.new_store_loc_data.selected_timezone_id
      : "";
  const ownerValue = storeOwnerIdForSave(loggedUserDetails, currentStateData);

  let error = false;
  let errorMessages = {};

  if (validateEmpty(storeName).error === true) {
    error = true;
    errorMessages = { ...errorMessages, store_name: "Store name must not be empty" };
  }
  if (storeCountry === "") {
    error = true;
    errorMessages = { ...errorMessages, store_country: "Please select the country" };
  }
  if (storeRegion === "") {
    error = true;
    errorMessages = { ...errorMessages, store_region: "Please select the region" };
  }
  if (newRegion === true) {
    const validateRegionName = validateEmpty(newRegionName);
    const validateRegionCode = validateEmpty(newRegionCode);
    if (validateRegionName.error === true) {
      error = true;
      errorMessages = { ...errorMessages, new_region_name: "Region name must not be empty and may not contain special characters" };
    } else {
      const existingRegionNames = (currentStateData.regions_list || []).map((r) => r.label);
      if (existingRegionNames.includes(newRegionName)) {
        error = true;
        errorMessages = { ...errorMessages, new_region_name: "Region name already exists" };
      }
    }
    if (validateRegionCode.error === true) {
      error = true;
      errorMessages = { ...errorMessages, new_region_code: "Region code must not be empty and may not contain special characters" };
    }
  }
  if (validateEmpty(storeStreet).error === true) {
    error = true;
    errorMessages = { ...errorMessages, store_street: "Street & no. must not be empty" };
  }
  if (validateEmpty(storeZip).error === true) {
    error = true;
    errorMessages = { ...errorMessages, store_zip: "Zip code must not be empty" };
  }
  if (validateEmpty(storeCity).error === true) {
    error = true;
    errorMessages = { ...errorMessages, store_city: "City must not be empty" };
  }
  if (validateNegativeDecimalNumbers(longitude, true).error === true) {
    error = true;
    errorMessages = { ...errorMessages, longitude: "Longitude cannot be empty or contain letters. Use period as decimal separator" };
  }
  if (validateNegativeDecimalNumbers(latitude, true).error === true) {
    error = true;
    errorMessages = { ...errorMessages, latitude: "Latitude cannot be empty or contain letters. Use period as decimal separator" };
  }
  if (selectedTimezoneId === "") {
    error = true;
    errorMessages = { ...errorMessages, selected_timezone: "Please select the timezone" };
  }
  if (ownerValue === "") {
    error = true;
    errorMessages = { ...errorMessages, share_list_selection: "Please make a selection" };
  }

  if (error === true) {
    toast("Please fill in valid information", { type: "error" });
    return { error: true, errorMessages };
  }
  return { error: false, errorMessages: {} };
};

// openKey/closeKey are the property names for start/end time strings ("HH:mm").
// Returns the indexes of every range that overlaps another one. Indexes rather
// than a boolean so the caller can key the error to the offending row — a
// schedule-only flag left the save-time scroll without a target.
const overlappingRangeIndexes = (ranges, openKey, closeKey) => {
  const hits = new Set();
  for (let i = 0; i < ranges.length; i++) {
    for (let j = i + 1; j < ranges.length; j++) {
      const a = ranges[i];
      const b = ranges[j];
      if (!a[openKey] || !a[closeKey] || !b[openKey] || !b[closeKey]) continue;
      // Normalize end-of-day close values so a 23:40 → 00:00 range correctly
      // compares against earlier ranges as if it ended at midnight.
      const aClose = normalizeCloseTime(a[closeKey]);
      const bClose = normalizeCloseTime(b[closeKey]);
      if (!(aClose <= b[openKey] || a[openKey] >= bClose)) {
        hits.add(i);
        hits.add(j);
      }
    }
  }
  return hits;
};

// Validates Step 2 — Opening Hours schedules
// Checks are run on Next click, not live
export const validateStoreOpeningHours = () => {
  const currentStateData = store.getState().userSelections;
  const schedules =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.opening_schedules !== "undefined"
      ? currentStateData.new_store_loc_data.opening_schedules
      : [];

  let error = false;
  let errorMessages = {};
  // Schedules whose card must be expanded so the user can see the error.
  // Tracked directly (not derived from error keys) so keyless failures like
  // intra-day range overlaps also surface a collapsed card.
  const schedulesWithErrors = new Set();

  if (schedules.length === 0) {
    error = true;
    errorMessages = { ...errorMessages, schedules: "At least one opening schedule is required" };
    toast("Please fill in valid information", { type: "error" });
    return { error: true, errorMessages };
  }

  const today = new Date().toISOString().slice(0, 10);

  // Skip inactive and expired schedules, they are not part of coverage checks.
  const activeSchedules = schedules.filter(
    (s) => s.active !== false && !(!s.no_end && s.validity_end && s.validity_end < today)
  );

  const noEndCount = activeSchedules.filter((s) => s.no_end === true).length;
  if (noEndCount !== 1) {
    error = true;
    errorMessages = { ...errorMessages, no_end: "Exactly one schedule must be defined without an end date" };
  }

  const dayNames = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

  // Name stays editable on expired/inactive cards, so validate it on every schedule.
  schedules.forEach((schedule) => {
    if (!schedule.name || schedule.name.trim() === "") {
      error = true;
      schedulesWithErrors.add(schedule.id);
      errorMessages = { ...errorMessages, ["name_" + schedule.id]: "Name is required" };
    }
  });

  activeSchedules.forEach((schedule) => {
    if (!schedule.validity_start) {
      error = true;
      schedulesWithErrors.add(schedule.id);
      const key = "start_" + schedule.id;
      errorMessages = { ...errorMessages, [key]: "Start date required" };
    }
    if (!schedule.no_end && !schedule.validity_end) {
      error = true;
      schedulesWithErrors.add(schedule.id);
      const key = "end_" + schedule.id;
      errorMessages = { ...errorMessages, [key]: "End date required" };
    }
    if (
      schedule.validity_start && !schedule.no_end && schedule.validity_end &&
      schedule.validity_start < today && schedule.validity_end < today
    ) {
      error = true;
      schedulesWithErrors.add(schedule.id);
      const key = "end_" + schedule.id;
      errorMessages = { ...errorMessages, [key]: "Schedule cannot be entirely in the past" };
    }

    const hasOpenDay = dayNames.some((d) => schedule.weekdays[d].open === true);
    if (!hasOpenDay) {
      error = true;
      schedulesWithErrors.add(schedule.id);
      const key = "days_" + schedule.id;
      errorMessages = { ...errorMessages, [key]: "At least one day must be open" };
    }

    dayNames.forEach((day) => {
      if (!schedule.weekdays[day].open || schedule.weekdays[day].is_24h) return;
      const ranges = schedule.weekdays[day].time_ranges || [];
      // Per-day mode: an open, non-24h day with no ranges at all is incomplete.
      if (!schedule.same_times_all_days && ranges.length === 0) {
        error = true;
        schedulesWithErrors.add(schedule.id);
        errorMessages = { ...errorMessages, [`time_gap_${schedule.id}_${day}_0`]: "Opening and closing time required" };
      }
      ranges.forEach((range, idx) => {
        const key = `time_gap_${schedule.id}_${day}_${idx}`;
        // A half-filled range (a time field left incomplete) must block save
        // instead of silently keeping a stale value. Only meaningful per-day —
        // when Same Times is on these ranges are unused.
        if (!range.open || !range.close) {
          if (!schedule.same_times_all_days) {
            error = true;
            schedulesWithErrors.add(schedule.id);
            errorMessages = { ...errorMessages, [key]: "Opening and closing time required" };
          }
          return;
        }
        if (isInvertedRange(range.open, range.close)) {
          error = true;
          schedulesWithErrors.add(schedule.id);
          errorMessages = { ...errorMessages, [key]: "End time must be after start time" };
        }
      });
      // Overlap within this day's ranges (live UI already shows it, but also block
      // save). Keyed per range so the save-time scroll has a target; the row
      // derives the displayed text live, so an existing key is left untouched.
      if (!schedule.same_times_all_days) {
        overlappingRangeIndexes(ranges, "open", "close").forEach((idx) => {
          error = true;
          schedulesWithErrors.add(schedule.id);
          const key = `time_gap_${schedule.id}_${day}_${idx}`;
          if (!errorMessages[key]) {
            errorMessages = { ...errorMessages, [key]: "Overlaps with another time range" };
          }
        });
      }
    });

    // Validate same_times_ranges when same_times_all_days is active
    if (schedule.same_times_all_days && !schedule.same_times_is_24h) {
      const stRanges = schedule.same_times_ranges || [];
      // An open schedule that shares times needs at least one complete range.
      if (stRanges.length === 0) {
        error = true;
        schedulesWithErrors.add(schedule.id);
        errorMessages = { ...errorMessages, [`same_time_gap_${schedule.id}_0`]: "Opening and closing time required" };
      }
      stRanges.forEach((range, idx) => {
        const key = `same_time_gap_${schedule.id}_${idx}`;
        // A half-filled range must block save instead of keeping a stale value.
        if (!range.open || !range.close) {
          error = true;
          schedulesWithErrors.add(schedule.id);
          errorMessages = { ...errorMessages, [key]: "Opening and closing time required" };
          return;
        }
        if (isInvertedRange(range.open, range.close)) {
          error = true;
          schedulesWithErrors.add(schedule.id);
          errorMessages = { ...errorMessages, [key]: "End time must be after start time" };
        }
      });
      overlappingRangeIndexes(stRanges, "open", "close").forEach((idx) => {
        error = true;
        schedulesWithErrors.add(schedule.id);
        const key = `same_time_gap_${schedule.id}_${idx}`;
        if (!errorMessages[key]) {
          errorMessages = { ...errorMessages, [key]: "Overlaps with another time range" };
        }
      });
    }
  });

  // Sort active schedules by start date for overlap/gap checks
  const sorted = [...activeSchedules]
    .filter((s) => s.validity_start)
    .sort((a, b) => (a.validity_start > b.validity_start ? 1 : -1));


  // Coverage/overlap/gap messages live in the Schedule Overview box, not inside
  // the card — so they must not expand the card either. Only errors rendered on
  // the card's own inputs go into schedulesWithErrors.
  if (sorted.length > 0 && sorted[0].validity_start > today) {
    error = true;
    errorMessages = {
      ...errorMessages,
      ["no_coverage_" + sorted[0].id]: "The store has no opening hours before this schedule.",
    };
  }

  // Overlap check: end of A >= start of B means overlap
  for (let i = 0; i < sorted.length - 1; i++) {
    const a = sorted[i];
    const b = sorted[i + 1];
    if (a.no_end || (a.validity_end && a.validity_end >= b.validity_start)) {
      error = true;
      errorMessages = {
        ...errorMessages,
        ["overlap_" + a.id]: "This schedule overlaps with another schedule",
        ["overlap_" + b.id]: "This schedule overlaps with another schedule",
      };
    }
  }

  // Gap check: end of A + 1 day must equal start of B (for non-no_end schedules)
  for (let i = 0; i < sorted.length - 1; i++) {
    const a = sorted[i];
    const b = sorted[i + 1];
    if (a.no_end || !a.validity_end) continue;
    const endPlusOne = new Date(a.validity_end);
    endPlusOne.setDate(endPlusOne.getDate() + 1);
    const endPlusOneStr = endPlusOne.toISOString().slice(0, 10);
    if (endPlusOneStr !== b.validity_start) {
      error = true;
      errorMessages = {
        ...errorMessages,
        ["gap_after_" + a.id]: "There is a gap after this schedule",
        ["gap_before_" + b.id]: "There is a gap before this schedule",
      };
    }
  }

  if (error === true) {
    // Expand any collapsed card that has an error so the user can act on it
    if (schedulesWithErrors.size > 0) {
      const existing = currentStateData.new_store_loc_data || {};
      const expanded = schedules.map((s) =>
        schedulesWithErrors.has(s.id) && s.is_collapsed ? { ...s, is_collapsed: false } : s
      );
      store.dispatch(
        updateStateData({ new_store_loc_data: { ...existing, opening_schedules: expanded } })
      );
    }
    toast("Please fill in valid information", { type: "error" });
    return { error: true, errorMessages };
  }
  return { error: false, errorMessages: {} };
};

// Validates Step 3 — Infrastructure Information fields
export const validateStoreInfraInfo = () => {
  const currentStateData = store.getState().userSelections;

  const retailerStoreId =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.retailer_store_id !== "undefined"
      ? currentStateData.new_store_loc_data.retailer_store_id
      : "";
  const storeTrolleys =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.store_trolleys !== "undefined"
      ? currentStateData.new_store_loc_data.store_trolleys
      : "";
  const storeBaskets =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.store_baskets !== "undefined"
      ? currentStateData.new_store_loc_data.store_baskets
      : "";
  const storeSize =
    typeof currentStateData.new_store_loc_data !== "undefined" &&
      typeof currentStateData.new_store_loc_data.store_size !== "undefined"
      ? currentStateData.new_store_loc_data.store_size
      : "";

  let error = false;
  let errorMessages = {};

  if (retailerStoreId !== "" && retailerStoreId !== null) {
    if (validateNumbers(retailerStoreId).error === true) {
      error = true;
      errorMessages = { ...errorMessages, retailer_store_id: "Retailer store id may not contain letters or negative values" };
    }
  }
  if (storeTrolleys !== "" && storeTrolleys !== null) {
    if (validateNumbers(storeTrolleys).error === true) {
      error = true;
      errorMessages = { ...errorMessages, store_trolleys: "Equipped trolleys may not contain letters or negative values" };
    }
  }
  if (storeBaskets !== "" && storeBaskets !== null) {
    if (validateNumbers(storeBaskets).error === true) {
      error = true;
      errorMessages = { ...errorMessages, store_baskets: "Equipped baskets may not contain letters or negative values" };
    }
  }
  if (storeSize !== "" && storeSize !== null) {
    if (validateNumbers(storeSize, true).error === true) {
      error = true;
      errorMessages = { ...errorMessages, store_size: "Store size must not be empty and may not contain letters or negative values" };
    }
  }

  if (error === true) {
    toast("Please fill in valid information", { type: "error" });
    return { error: true, errorMessages };
  }
  return { error: false, errorMessages: {} };
};

// ─────────────────────────────────────────────────────────────────────────────

// fetch countries
export const fetchCountriesList = async () => {
  const fetchCountries = await sendApiRequest("countries", {}, "GET", { skipRetailerViewFilter: true });
  //evaluate api response
  if (typeof fetchCountries.success !== "undefined" && fetchCountries.success === true) {
    store.dispatch(
      updateStateData({
        countries_list: fetchCountries.response,
      })
    );

    return {
      success: true,
    };
  } else {
    toast("Sorry, something went wrong", { type: "error" });
    return {
      success: false,
    };
  }
};

// fetch store overview details
export const fetchStoreOverviewDetails = async (storeId) => {
  const fetchStoreOverview = await sendApiRequest("stores/" + storeId, {}, "GET");

  //evaluate api response
  if (
    typeof fetchStoreOverview.response !== "undefined" &&
    typeof fetchStoreOverview.response.error !== "undefined" &&
    fetchStoreOverview.response.error === true
  ) {
    toast("Store data not found", { type: "error" });
    setTimeout(() => {
      window.location.href = "/infrastructure/locations";
    }, 2000);
    return {
      success: false,
    };
  } else {
    if (typeof fetchStoreOverview.success !== "undefined" && fetchStoreOverview.success === true) {
      store.dispatch(
        updateStateData({
          store_overview: fetchStoreOverview.response,
        })
      );

      return {
        success: true,
      };
    } else {
      toast("Sorry, something went wrong", { type: "error" });
      return {
        success: false,
      };
    }
  }
};

export const verifyStoreIP = async (storeId) => {
  const currentStateData = store.getState().userSelections;
  let error = false;
  let error_message = "";

  if (typeof currentStateData.store_ip_info !== "undefined") {
    if (
      typeof currentStateData.store_ip_info.second_octet === "undefined" ||
      currentStateData?.store_ip_info?.second_octet === ""
    ) {
      error = true;
      error_message = "Please define a Store IP Address";
    } else {
      // validate octet value
      const validate = octetValidation(currentStateData?.store_ip_info?.second_octet);
      if (validate.error === true) {
        error = true;
        error_message = validate.error_message;
      }
    }

    if (
      typeof currentStateData.store_ip_info.third_octet === "undefined" ||
      currentStateData?.store_ip_info?.third_octet === ""
    ) {
      error = true;
      error_message = "Please define a Store IP Address";
    } else {
      // validate octet value
      const validate = octetValidation(currentStateData?.store_ip_info?.third_octet);
      if (validate.error === true) {
        error = true;
        error_message = validate.error_message;
      }
    }
  } else {
    error = true;
    error_message = "Please define a Store IP Address";
  }

  // check for duplicacy
  if (error === false) {
    const ipDuplicacy = await duplicateIpCheck(storeId);
    if (ipDuplicacy.error === true) {
      error = true;
      error_message = "IP address not available. Please verify your input";
    }
  }

  return {
    error: error,
    error_message: error_message,
  };
};

// define the list of devices based on the device counts defined by user
export const defineDevicesList = () => {
  const currentStateData = store.getState().userSelections;
  const selectedDeviceCounts = currentStateData?.device_count_info;
  const dbDeviceInfo = typeof currentStateData.db_device_info !== "undefined" ? currentStateData.db_device_info : [];
  const storeIpInfo =
    "10." + currentStateData?.store_ip_info?.second_octet + "." + currentStateData?.store_ip_info?.third_octet;

  let deviceList = [];

  // screen area reader list
  if (selectedDeviceCounts?.screen_area_reader) {
    let lastOctetRangeForScreens = allNumbersBetweenRange(10, 99);
    // define screen and area reader devices
    for (let index = 0; index < selectedDeviceCounts.screen_area_reader; index++) {
      let deviceObj = {
        type: index === 0 ? "Master Screen" : "Screen",
        store_ip: storeIpInfo,
        ip_address: dbDeviceInfo.length !== 0 ? "" : storeIpInfo + "." + lastOctetRangeForScreens[0],
        last_octet: dbDeviceInfo.length !== 0 ? "" : lastOctetRangeForScreens[0],
        active: false,
        color_code: "#fff",
        area_reader: {
          type: "Area Reader",
          store_ip: storeIpInfo,
          ip_address: dbDeviceInfo.length !== 0 ? "" : storeIpInfo + "." + lastOctetRangeForScreens[1],
          last_octet: dbDeviceInfo.length !== 0 ? "" : lastOctetRangeForScreens[1],
          active: false,
        },
      };
      // we need to maintain the existing status of device (if it's already added)
      if (dbDeviceInfo.length !== 0 && typeof dbDeviceInfo.screens[index] !== "undefined") {
        const lastOctetForScreen = dbDeviceInfo.screens[index].ip_address.split(".");
        const lastOctetForAreaReader = dbDeviceInfo.screens[index].area_reader.ip_address.split(".");
        deviceObj = {
          ...deviceObj,
          id: dbDeviceInfo.screens[index].id,
          active: dbDeviceInfo.screens[index].active,
          ip_address: storeIpInfo + "." + lastOctetForScreen[3],
          last_octet: lastOctetForScreen[3],
          color_code: "#fff",
          area_reader: {
            ...deviceObj.area_reader,
            id: dbDeviceInfo.screens[index].area_reader.id,
            active: dbDeviceInfo.screens[index].area_reader.active,
            ip_address: storeIpInfo + "." + lastOctetForAreaReader[3],
            last_octet: lastOctetForAreaReader[3],
          },
        };
      }
      deviceList.push(deviceObj);
      // remove octets which are already used.
      lastOctetRangeForScreens.splice(0, 5);
    }
  }
  // checkout reader list
  if (selectedDeviceCounts?.checkout_reader) {
    let lastOctetRangeForCheckoutReaders = allNumbersBetweenRange(
      100,
      parseInt(100 + parseInt(selectedDeviceCounts.checkout_reader))
    );
    for (let index = 0; index < selectedDeviceCounts.checkout_reader; index++) {
      let deviceObj = {
        type: "Checkout Reader",
        store_ip: storeIpInfo,
        ip_address: dbDeviceInfo.length !== 0 ? "" : storeIpInfo + "." + lastOctetRangeForCheckoutReaders[0],
        last_octet: dbDeviceInfo.length !== 0 ? "" : lastOctetRangeForCheckoutReaders[0],
        active: false,
        color_code: "#E6E6E6",
      };
      // we need to maintain the existing status of device (if it's already added)
      if (dbDeviceInfo.length !== 0 && typeof dbDeviceInfo.checkout_readers[index] !== "undefined") {
        const lastOctetForCheckout = dbDeviceInfo.checkout_readers[index].ip_address.split(".");
        deviceObj = {
          ...deviceObj,
          id: dbDeviceInfo.checkout_readers[index].id,
          active: dbDeviceInfo.checkout_readers[index].active,
          ip_address: storeIpInfo + "." + lastOctetForCheckout[3],
          last_octet: lastOctetForCheckout[3],
          color_code: "#E6E6E6",
        };
      }
      deviceList.push(deviceObj);
      // remove octets which are already used.
      lastOctetRangeForCheckoutReaders.splice(0, 1);
    }
  }
  // checkin reader list
  if (selectedDeviceCounts?.checkin_reader) {
    let startNum = parseInt(100 + parseInt(selectedDeviceCounts.checkout_reader));
    let endNum = parseInt(startNum + parseInt(selectedDeviceCounts.checkin_reader));
    let lastOctetRangeForCheckInReaders = allNumbersBetweenRange(startNum, endNum);
    for (let index = 0; index < selectedDeviceCounts.checkin_reader; index++) {
      let deviceObj = {
        type: "Checkin Reader",
        store_ip: storeIpInfo,
        ip_address: dbDeviceInfo.length !== 0 ? "" : storeIpInfo + "." + lastOctetRangeForCheckInReaders[0],
        last_octet: dbDeviceInfo.length !== 0 ? "" : lastOctetRangeForCheckInReaders[0],
        active: false,
        color_code: "#fff",
      };
      // we need to maintain the existing status of device (if it's already added)
      if (dbDeviceInfo.length !== 0 && typeof dbDeviceInfo.checkin_readers[index] !== "undefined") {
        const lastOctetForCheckin = dbDeviceInfo.checkin_readers[index].ip_address.split(".");
        deviceObj = {
          ...deviceObj,
          id: dbDeviceInfo.checkin_readers[index].id,
          active: dbDeviceInfo.checkin_readers[index].active,
          ip_address: storeIpInfo + "." + lastOctetForCheckin[3],
          last_octet: lastOctetForCheckin[3],
          color_code: "#fff",
        };
      }
      deviceList.push(deviceObj);
      lastOctetRangeForCheckInReaders.splice(0, 1);
    }
  }
  // self checkout reader list
  if (selectedDeviceCounts?.self_checkout_reader) {
    let startNum = parseInt(
      100 + parseInt(selectedDeviceCounts.checkout_reader) + parseInt(selectedDeviceCounts.checkin_reader)
    );
    let endNum = parseInt(startNum + parseInt(selectedDeviceCounts.self_checkout_reader));
    let lastOctetRangeForSelfCheckOutReaders = allNumbersBetweenRange(startNum, endNum);
    for (let index = 0; index < selectedDeviceCounts.self_checkout_reader; index++) {
      let deviceObj = {
        type: "Self Checkout Reader",
        store_ip: storeIpInfo,
        ip_address: dbDeviceInfo.length !== 0 ? "" : storeIpInfo + "." + lastOctetRangeForSelfCheckOutReaders[0],
        last_octet: dbDeviceInfo.length !== 0 ? "" : lastOctetRangeForSelfCheckOutReaders[0],
        active: false,
        color_code: "#E6E6E6",
      };
      // we need to maintain the existing status of device (if it's already added)
      if (dbDeviceInfo.length !== 0 && typeof dbDeviceInfo.self_checkout_readers[index] !== "undefined") {
        const lastOctetForSelfCheckout = dbDeviceInfo.self_checkout_readers[index].ip_address.split(".");
        deviceObj = {
          ...deviceObj,
          id: dbDeviceInfo.self_checkout_readers[index].id,
          active: dbDeviceInfo.self_checkout_readers[index].active,
          ip_address: storeIpInfo + "." + lastOctetForSelfCheckout[3],
          last_octet: lastOctetForSelfCheckout[3],
          color_code: "#E6E6E6",
        };
      }
      deviceList.push(deviceObj);
      lastOctetRangeForSelfCheckOutReaders.splice(0, 1);
    }
  }
  // Instore reader without screen list
  if (selectedDeviceCounts?.instore_reader_without_screen) {
    let startNum = parseInt(
      100 +
      parseInt(selectedDeviceCounts.checkout_reader) +
      parseInt(selectedDeviceCounts.checkin_reader) +
      parseInt(selectedDeviceCounts.self_checkout_reader)
    );
    let endNum = parseInt(startNum + parseInt(selectedDeviceCounts.instore_reader_without_screen));
    let lastOctetRangeForInstoreReader = allNumbersBetweenRange(startNum, endNum);
    for (let index = 0; index < selectedDeviceCounts.instore_reader_without_screen; index++) {
      let deviceObj = {
        type: "Instore Reader Without Screen",
        store_ip: storeIpInfo,
        ip_address: dbDeviceInfo.length !== 0 ? "" : storeIpInfo + "." + lastOctetRangeForInstoreReader[0],
        last_octet: dbDeviceInfo.length !== 0 ? "" : lastOctetRangeForInstoreReader[0],
        active: false,
        color_code: "#fff",
      };
      // we need to maintain the existing status of device (if it's already added)
      if (dbDeviceInfo.length !== 0 && typeof dbDeviceInfo.instore_readers_without_screen[index] !== "undefined") {
        const lastOctetForInstore = dbDeviceInfo.instore_readers_without_screen[index].ip_address.split(".");
        deviceObj = {
          ...deviceObj,
          id: dbDeviceInfo.instore_readers_without_screen[index].id,
          ip_address: storeIpInfo + "." + lastOctetForInstore[3],
          active: dbDeviceInfo.instore_readers_without_screen[index].active,
          last_octet: lastOctetForInstore[3],
          color_code: "#fff",
        };
      }
      deviceList.push(deviceObj);
      lastOctetRangeForInstoreReader.splice(0, 1);
    }
  }

  store.dispatch(
    updateStateData({
      device_list: deviceList,
    })
  );
};

export const duplicateOctetCheck = (octetInfo, index, area_reader_validation = false) => {
  let error = false;
  let errorMessage = "";
  // validate for duplicateValue
  const duplicateCheck = fetchLastOctetList(index, area_reader_validation);
  if (duplicateCheck.includes(parseInt(octetInfo.last_octet)) || parseInt(octetInfo.last_octet) === 10) {
    error = true;
    errorMessage = "Each device must have a unique IP octet";
  } else {
    // validate octet rule
    const validate = octetValidation(octetInfo.last_octet, true);
    if (validate.error === true) {
      error = true;
      errorMessage = validate.error_message;
    } else {
      error = false;
    }
  }
  return {
    error,
    errorMessage,
  };
};

export const octetValidation = (octetValue, last_octet = false) => {
  const validateOctetForNumber = validateNumbers(octetValue);
  if (validateOctetForNumber.error === true) {
    return {
      error: true,
      error_message: "IP octets must be between 11-255 and cannot be negative, empty, or contain letters",
    };
  } else {
    if (parseInt(octetValue) < 0 || parseInt(octetValue) > 255) {
      return {
        error: true,
        error_message: "IP octets must be between 0-255 and cannot be negative, empty, or contain letters",
      };
    } else {
      if (last_octet === true) {
        if (parseInt(octetValue) < 11 || parseInt(octetValue) > 255) {
          return {
            error: true,
            error_message: "IP octets must be between 11-255 and cannot be negative, empty, or contain letters",
          };
        }
      }
    }

    return {
      error: false,
      error_message: "",
    };
  }
};

export const fetchLastOctetList = (indexToExclude, areaReaderValidation = false) => {
  const currentStateData = store.getState().userSelections;
  // validate duplicate ip's based on last octet (because initia 3 octets are fixed being defined as store ip)
  const deviceInfo = typeof currentStateData.device_list !== "undefined" ? currentStateData.device_list : [];
  // get a list of last octets
  let lastOctetValues = [];
  if (deviceInfo.length !== 0) {
    deviceInfo.forEach((device, index) => {
      if (device.active === true) {
        if (index !== indexToExclude) {
          lastOctetValues.push(parseInt(device.last_octet));
          if (typeof device.area_reader !== "undefined") {
            lastOctetValues.push(parseInt(device.area_reader.last_octet));
          }
        } else {
          if (areaReaderValidation === true) {
            lastOctetValues.push(parseInt(device.last_octet));
          }
        }
      }
    });
  }
  return lastOctetValues;
};

export const checkDeviceStatus = () => {
  const currentStateData = store.getState().userSelections;
  let deviceStatusArray = [];
  if (typeof currentStateData.device_list !== "undefined" && currentStateData.device_list.length !== 0) {
    currentStateData.device_list.forEach((device, index) => {
      deviceStatusArray.push(device.active);
    });
  }

  return deviceStatusArray.length !== 0 ? deviceStatusArray.includes(true) : false;
};

export const validateDeviceList = () => {
  const currentStateData = store.getState().userSelections;
  let errorDetails = {};
  let error = false;
  let deviceStatusArray = [];
  let areaReaderErrorIndexes = [];
  // validate devices
  if (typeof currentStateData.device_list !== "undefined" && currentStateData.device_list.length !== 0) {
    currentStateData.device_list.forEach((device, index) => {
      if (device.active === true) {
        let checkRules = duplicateOctetCheck({ last_octet: device.last_octet }, index, false);
        // validate area reader info
        if (device.type === "Master Screen" || device.type === "Screen") {
          let checkAreaReaderInfo = duplicateOctetCheck({ last_octet: device.area_reader.last_octet }, index, true);

          if (checkAreaReaderInfo.error === true) {
            error = true;
            errorDetails = {
              ...errorDetails,
              [index]: checkAreaReaderInfo.errorMessage,
            };
            areaReaderErrorIndexes = [...areaReaderErrorIndexes, index];
          }
        }

        if (checkRules.error === true && device.type !== "Master Screen") {
          error = true;
          errorDetails = {
            ...errorDetails,
            [index]: checkRules.errorMessage,
          };
        }
        deviceStatusArray.push(device.active);
      }
    });
  }

  return {
    error,
    errorDetails,
    deviceStatusArray,
    areaReaderErrorIndexes,
  };
};

// validate duplicate ip's and save device info to backend database
export const saveDevicesInfo = async (storeId, storeActiveStatus = "") => {
  const currentStateData = store.getState().userSelections;
  // validate duplicate ip's based on last octet (because initia 3 octets are fixed being defined as store ip)
  const deviceInfo = typeof currentStateData.device_list !== "undefined" ? currentStateData.device_list : [];
  let deviceRequest = {
    screens: [],
    checkout_readers: [],
    checkin_readers: [],
    self_checkout_readers: [],
    instore_readers_without_screen: [],
  };

  if (storeActiveStatus !== "") {
    deviceRequest = {
      ...deviceRequest,
      store_active: storeActiveStatus,
    };
  }

  if (deviceInfo.length !== 0) {
    deviceInfo.forEach((device) => {
      // screens
      if (device.type === "Master Screen" || device.type === "Screen") {
        deviceRequest = {
          ...deviceRequest,
          screens: [
            ...deviceRequest.screens,
            {
              ...device,
              type: device.type,
              ip_address: device.ip_address,
              active: device.active,
              area_reader: {
                ...device.area_reader,
                ip_address: device.area_reader.ip_address,
                active: device.area_reader.active,
              },
            },
          ],
        };
      }
      // checkout readers
      if (device.type === "Checkout Reader") {
        deviceRequest = {
          ...deviceRequest,
          checkout_readers: [
            ...deviceRequest.checkout_readers,
            {
              ...device,
              ip_address: device.ip_address,
              // number_checkout: [99, 1, 2, 3, 4, 5, 99],
              active: device.active,
            },
          ],
        };
      }
      // checkin readers
      if (device.type === "Checkin Reader") {
        deviceRequest = {
          ...deviceRequest,
          checkin_readers: [
            ...deviceRequest.checkin_readers,
            {
              ...device,
              ip_address: device.ip_address,
              active: device.active,
            },
          ],
        };
      }
      // Self Checkout Reader
      if (device.type === "Self Checkout Reader") {
        deviceRequest = {
          ...deviceRequest,
          self_checkout_readers: [
            ...deviceRequest.self_checkout_readers,
            {
              ...device,
              ip_address: device.ip_address,
              active: device.active,
            },
          ],
        };
      }
      // instore_readers_without_screen
      if (device.type === "Instore Reader Without Screen") {
        deviceRequest = {
          ...deviceRequest,
          instore_readers_without_screen: [
            ...deviceRequest.instore_readers_without_screen,
            {
              ...device,
              ip_address: device.ip_address,
              active: device.active,
            },
          ],
        };
      }
    });

    const saveDeviceList = await sendApiRequest("stores/" + storeId + "/devices/save", deviceRequest, "POST");
    //evaluate api response
    if (typeof saveDeviceList.success !== "undefined" && saveDeviceList.success === true) {
      toast("Devices saved successfully", { type: "success" });

      // this function will reset and fetch devices from backend to get updated data.
      discardChanges(storeId);
      store.dispatch(
        updateStateData({
          locked_ip: true,
        })
      );
      return {
        success: true,
      };
    } else {
      toast("Sorry, something went wrong", { type: "error" });
      return {
        success: false,
      };
    }
  }
};

// fetch device list from backend
export const fetchDeviceList = async (storeId) => {
  const fetchDevices = await sendApiRequest("stores/" + storeId + "/devices", {}, "GET");
  //evaluate api response
  if (typeof fetchDevices.success !== "undefined" && fetchDevices.success === true) {
    let deviceInfoObj = {};
    let deviceListInfo = [];
    const staticResponse = fetchDevices.response;

    // set store ip info and device count info
    const splittedStoreIp = staticResponse.store_ip.split(".");
    deviceInfoObj = {
      store_ip_info: {
        second_octet: splittedStoreIp[1],
        third_octet: splittedStoreIp[2],
      },
      db_store_ip: {
        second_octet: splittedStoreIp[1],
        third_octet: splittedStoreIp[2],
        store_ip: staticResponse.store_ip,
      },
      device_count_info: {
        screen_area_reader: staticResponse.screens.length,
        checkout_reader: staticResponse.checkout_readers.length,
        checkin_reader: staticResponse.checkin_readers.length,
        self_checkout_reader: staticResponse.self_checkout_readers.length,
        instore_reader_without_screen: staticResponse.instore_readers_without_screen.length,
      },
      db_device_info: {
        screens: staticResponse.screens,
        checkout_readers: staticResponse.checkout_readers.sort((next, prev) => {
          var nextIpOctets = next.ip_address.split(".");
          var prevIpOctets = prev.ip_address.split(".");
          var nextIPLastOctet = parseInt(nextIpOctets[nextIpOctets.length - 1]);
          var prevIPLastOctet = parseInt(prevIpOctets[prevIpOctets.length - 1]);
          return nextIPLastOctet - prevIPLastOctet;
        }),
        checkin_readers: staticResponse.checkin_readers,
        self_checkout_readers: staticResponse.self_checkout_readers,
        instore_readers_without_screen: staticResponse.instore_readers_without_screen,
      },
    };
    // screens info
    if (typeof staticResponse.screens !== "undefined") {
      let screenReaders = [];
      staticResponse.screens.forEach((screenInfo) => {
        const lastOctetForScreen = screenInfo.ip_address.split(".");
        const lastOctetForAreaReader = screenInfo.area_reader.ip_address.split(".");

        screenReaders = [
          ...screenReaders,
          {
            id: screenInfo.id,
            type: screenInfo.type,
            store_ip: staticResponse.store_ip,
            ip_address: screenInfo.ip_address,
            last_octet: lastOctetForScreen[3],
            active: screenInfo.active,
            color_code: "#fff",
            area_reader: {
              type: "Area Reader",
              id: screenInfo.area_reader.id,
              store_ip: staticResponse.store_ip,
              ip_address: screenInfo.area_reader.ip_address,
              last_octet: lastOctetForAreaReader[3],
              active: screenInfo.area_reader.active,
            },
          },
        ].sort((a, b) => {
          return a.last_octet - b.last_octet;
        });
      });
      deviceListInfo = [...deviceListInfo, ...screenReaders];
    }
    // checkout readers
    if (typeof staticResponse.checkout_readers !== "undefined") {
      let checkoutReaders = [];
      staticResponse.checkout_readers.forEach((ReaderInfo) => {
        const lastOctetForCheckoutReader = ReaderInfo.ip_address.split(".");
        checkoutReaders = [
          ...checkoutReaders,
          {
            type: "Checkout Reader",
            id: ReaderInfo.id,
            store_ip: staticResponse.store_ip,
            ip_address: ReaderInfo.ip_address,
            last_octet: lastOctetForCheckoutReader[3],
            active: ReaderInfo.active,
            color_code: "#E6E6E6",
          },
        ].sort((a, b) => {
          return a.last_octet - b.last_octet;
        });
      });
      deviceListInfo = [...deviceListInfo, ...checkoutReaders];
    }
    // checkin reader
    if (typeof staticResponse.checkin_readers !== "undefined") {
      let checkInReaders = [];
      staticResponse.checkin_readers.forEach((ReaderInfo) => {
        const lastOctetForCheckInReader = ReaderInfo.ip_address.split(".");
        checkInReaders = [
          ...checkInReaders,
          {
            type: "Checkin Reader",
            id: ReaderInfo.id,
            store_ip: staticResponse.store_ip,
            ip_address: ReaderInfo.ip_address,
            last_octet: lastOctetForCheckInReader[3],
            active: ReaderInfo.active,
            color_code: "#fff",
          },
        ].sort((a, b) => {
          return a.last_octet - b.last_octet;
        });
      });
      deviceListInfo = [...deviceListInfo, ...checkInReaders];
    }
    // self checkout reader
    if (typeof staticResponse.self_checkout_readers !== "undefined") {
      let selfCheckoutReader = [];
      staticResponse.self_checkout_readers.forEach((ReaderInfo) => {
        const lastOctetForSelfCheckOutReader = ReaderInfo.ip_address.split(".");
        selfCheckoutReader = [
          ...selfCheckoutReader,
          {
            type: "Self Checkout Reader",
            id: ReaderInfo.id,
            store_ip: staticResponse.store_ip,
            ip_address: ReaderInfo.ip_address,
            last_octet: lastOctetForSelfCheckOutReader[3],
            active: ReaderInfo.active,
            color_code: "#E6E6E6",
          },
        ].sort((a, b) => {
          return a.last_octet - b.last_octet;
        });
      });
      deviceListInfo = [...deviceListInfo, ...selfCheckoutReader];
    }
    // instore reader without screen
    if (typeof staticResponse.instore_readers_without_screen !== "undefined") {
      let instoreReaders = [];
      staticResponse.instore_readers_without_screen.forEach((ReaderInfo) => {
        const lastOctetForInstoreReader = ReaderInfo.ip_address.split(".");
        instoreReaders = [
          ...instoreReaders,
          {
            type: "Instore Reader Without Screen",
            store_ip: staticResponse.store_ip,
            id: ReaderInfo.id,
            ip_address: ReaderInfo.ip_address,
            last_octet: lastOctetForInstoreReader[3],
            active: ReaderInfo.active,
            color_code: "#fff",
          },
        ].sort((a, b) => {
          return a.last_octet - b.last_octet;
        });
      });
      deviceListInfo = [...deviceListInfo, ...instoreReaders];
    }

    deviceInfoObj = {
      ...deviceInfoObj,
      device_list: deviceListInfo,
      db_device_count: deviceInfoObj.device_count_info,
      db_device_list: deviceListInfo,
    };

    store.dispatch(updateStateData(deviceInfoObj));

    return {
      success: true,
    };
  } else {
    // toast("Sorry, something went wrong", { type: "error" });
    return {
      success: false,
    };
  }
};

export const fetchConfigureLocationData = (id) => {
  setBatchLoadingStatus(true);
  fetchStoreOverviewDetails(id).then((overviewResponse) => {
    fetchOpeningHours();
    fetchDeviceList(id).then((info) => {
      fetchCheckoutCounters(id);
      fetchCheckoutTypeList();
      fetchCheckoutMapping(id);
      fetchInfraNote(id);
      fetchCyreenNote(id);
    });
  }).finally(setBatchLoadingStatus(false));
};

//
export const reset_infrastructure_config_page_data = (id) => {
  store.dispatch(
    deleteItems([
      "device_list",
      "db_device_count",
      "store_overview",
      "db_device_info",
      "device_count_info",
      "store_ip_info",
      "db_store_ip",
      "checkout_count_info",
      "checkout_layout_list",
      "track_infra_changes",
      "infra_note",
      "infra_cyreen_note",
      "cyreen_note_id",
      "note_id",
      "multiplexer_device_ports",
      "assigned_multiplexer",
      "checkout_mapping",
      "new_store_loc_data",
      "checkout_type_list",
      "db_checkout_layout_list",
      "db_checkout_count_info",
      "db_device_list",
      "db_checkout_mapping",
      "temporary_checkout_info",
      "locked_ip",
    ])
  );

  if (typeof id !== "undefined" && id !== "") {
    fetchConfigureLocationData(id);
  }
};

export const discardChanges = (storeId) => {
  reset_infrastructure_config_page_data(storeId);
};

export const checkoutTypeId = (checkoutName) => {
  const userStateData = store.getState().userSelections;
  let checkoutTypeId = "";
  if (typeof userStateData.checkout_type_list !== "undefined") {
    userStateData.checkout_type_list.forEach((checkoutType) => {
      if (checkoutType.name === checkoutName) {
        checkoutTypeId = checkoutType.id;
      }
    });
  }
  return checkoutTypeId;
};

export const fetchCheckoutTypeList = async () => {
  const fetchList = await sendApiRequest("stores/counters/types", {}, "GET", { skipRetailerViewFilter: true });
  //evaluate api response
  if (typeof fetchList.success !== "undefined" && fetchList.success === true) {
    store.dispatch(
      updateStateData({
        checkout_type_list: fetchList.response,
      })
    );

    return {
      success: true,
    };
  } else {
    return {
      success: false,
    };
  }
};

export const fetchCheckoutCounters = async (storeId) => {
  const fetchCounters = await sendApiRequest("stores/" + storeId + "/counters", {}, "GET");
  //evaluate api response
  if (typeof fetchCounters.success !== "undefined" && fetchCounters.success === true) {
    let counterInfoInfoObj = [];

    fetchCounters.response.forEach((counterInfo) => {
      counterInfoInfoObj = [
        ...counterInfoInfoObj,
        {
          id: counterInfo.id,
          active: counterInfo.active,
          system_co_number: counterInfo.system_checkout_number,
          instore_co_number: counterInfo.store_checkout_number,
          checkout_type: counterInfo.checkout_type,
          checkout_type_id: counterInfo.checkout_type_id,
          description: counterInfo.description,
          cap_enabled: counterInfo.cap_enabled,
          active: counterInfo.active,
          edit_disabled: true,
        },
      ];
    });

    store.dispatch(
      updateStateData({
        checkout_layout_list: counterInfoInfoObj,
        checkout_count_info: counterInfoInfoObj.length,
        db_checkout_count_info: counterInfoInfoObj.length,
        db_checkout_layout_list: counterInfoInfoObj,
      })
    );

    // checkout counters are sorted based on instore number (by default ascending)
    sortCheckoutEntries(
      { instore_num: true, system_num: false },
      {
        instore_num: "asc",
      }
    );

    return {
      success: true,
    };
  } else {
    // toast("Sorry, something went wrong", { type: "error" });
    return {
      success: false,
    };
  }
};

export const sortCheckoutEntries = (sortingParam, sortingMeasure) => {
  const userStateData = store.getState().userSelections;
  const activeRecords =
    typeof userStateData.checkout_layout_list !== "undefined" && userStateData.checkout_layout_list.length !== 0
      ? userStateData.checkout_layout_list.filter((checkoutObj) => {
        return checkoutObj.active === true ? true : false;
      })
      : [];
  const inActiveRecords =
    typeof userStateData.checkout_layout_list !== "undefined" && userStateData.checkout_layout_list.length !== 0
      ? userStateData.checkout_layout_list.filter((checkoutObj) => {
        return checkoutObj.active === false ? true : false;
      })
      : [];

  const sortedActiveList =
    activeRecords.length !== 0
      ? activeRecords.slice().sort((a, b) => {
        if (sortingParam.instore_num === true) {
          return sortingMeasure.instore_num === "asc"
            ? a.instore_co_number - b.instore_co_number
            : b.instore_co_number - a.instore_co_number;
        } else {
          //
          return sortingMeasure.system_num === "asc"
            ? a.system_co_number - b.system_co_number
            : b.system_co_number - a.system_co_number;
        }
      })
      : [];

  const sortedInActiveList =
    inActiveRecords.length !== 0
      ? inActiveRecords.slice().sort((a, b) => {
        if (sortingParam.instore_num === true) {
          return sortingMeasure.instore_num === "asc"
            ? a.instore_co_number - b.instore_co_number
            : b.instore_co_number - a.instore_co_number;
        } else {
          //
          return sortingMeasure.system_num === "asc"
            ? a.system_co_number - b.system_co_number
            : b.system_co_number - a.system_co_number;
        }
      })
      : [];

  store.dispatch(
    updateStateData({
      ...userStateData,
      checkout_layout_list: [...sortedActiveList, ...sortedInActiveList],
    })
  );
};

// to define checkout layout entries
export const defineCheckoutEntries = () => {
  const currentStateData = store.getState().userSelections;
  let checkoutEntries = [];
  const checkoutTypeName =
    typeof currentStateData.checkout_type_list !== "undefined"
      ? currentStateData.checkout_type_list[0].name
      : "regular checkout";
  const checkoutLayoutList =
    typeof currentStateData.checkout_layout_list !== "undefined" ? currentStateData.checkout_layout_list : [];

  let checkoutCounter =
    typeof currentStateData.temporary_checkout_info !== "undefined" ? currentStateData.temporary_checkout_info : 0;

  if (checkoutCounter !== 0) {
    // check existing count
    checkoutCounter =
      typeof currentStateData.checkout_count_info !== "undefined"
        ? parseInt(checkoutCounter) + parseInt(currentStateData.checkout_count_info)
        : parseInt(checkoutCounter);

    for (let index = 0; index < checkoutCounter; index++) {
      let checkoutObj = {};
      if (checkoutLayoutList.length !== 0 && typeof checkoutLayoutList[index] !== "undefined") {
        checkoutObj = {
          ...checkoutLayoutList[index],
        };
      } else {
        checkoutObj = {
          instore_co_number: "",
          system_co_number: "",
          checkout_type: checkoutTypeName,
          checkout_type_id: checkoutTypeId(checkoutTypeName),
          description: "",
          cap_enabled: true,
          active: true,
          edit_disabled: false,
        };
      }

      checkoutEntries.push(checkoutObj);
    }

    store.dispatch(
      updateStateData({
        checkout_layout_list: checkoutEntries,
        checkout_count_info: checkoutCounter,
        temporary_checkout_info: "",
      })
    );

    // sortCheckoutEntries(
    //   { instore_num: true, system_num: false },
    //   {
    //     instore_num: "asc",
    //   }
    // );
  }
};

// validate checkout layout entries
export const validateCheckoutEntries = () => {
  const currentStateData = store.getState().userSelections;
  let error = false;
  let errorDetails = {};
  let verifiedInstoreNum = [];
  let verifiedSystemNum = [];
  if (typeof currentStateData.checkout_layout_list !== "undefined" && currentStateData.checkout_layout_list.length !== 0) {
    currentStateData.checkout_layout_list.forEach((checkout, index) => {
      // validate instore checkout number
      const validateInstoreCheckout = validateNumbers(checkout.instore_co_number);
      const validateSystemCheckout = validateNumbers(checkout.system_co_number);

      // instore checkout
      if (validateInstoreCheckout.error === true) {
        error = true;
        errorDetails = {
          ...errorDetails,
          [index]: {
            ...errorDetails[index],
            instore_co_number: "Checkout Number cannot be negative, empty, or contain letters",
          },
        };
      } else {
        if (verifiedInstoreNum.includes(parseInt(checkout.instore_co_number))) {
          error = true;
          errorDetails = {
            ...errorDetails,
            [index]: {
              ...errorDetails[index],
              instore_co_number: "Each Checkout must have a unique In-Store Checkout Number",
            },
          };
        }
      }
      // system checkout
      if (validateSystemCheckout.error === true) {
        error = true;
        errorDetails = {
          ...errorDetails,
          [index]: {
            ...errorDetails[index],
            system_co_number: "Checkout Number cannot be negative, empty, or contain letters",
          },
        };
      } else {
        if (verifiedSystemNum.includes(parseInt(checkout.system_co_number))) {
          error = true;
          errorDetails = {
            ...errorDetails,
            [index]: {
              ...errorDetails[index],
              system_co_number: "Each Checkout must have a unique System Checkout Number",
            },
          };
        }
      }
      // description
      if (checkout.description !== "" && checkout.description !== null) {
        const validateDescription = validateAlphanumeric(checkout.description);
        if (validateDescription.error === true) {
          error = true;
          errorDetails = {
            ...errorDetails,
            [index]: {
              ...errorDetails[index],
              description: "Description may not have special characters",
            },
          };
        }
      }

      verifiedInstoreNum.push(parseInt(checkout.instore_co_number));
      verifiedSystemNum.push(parseInt(checkout.system_co_number));
    });
  }

  return {
    error,
    errorDetails,
  };
};

export const saveCheckoutLayoutInfo = async (storeId) => {
  const currentStateData = store.getState().userSelections;
  if (typeof currentStateData.checkout_layout_list !== "undefined" && currentStateData.checkout_layout_list.length !== 0) {
    let checkoutRequest = currentStateData.checkout_layout_list.map((checkout) => {
      return {
        ...checkout,
        checkout_type: checkout.checkout_type_id,
        store_checkout_number: parseInt(checkout.instore_co_number),
        system_checkout_number: parseInt(checkout.system_co_number),
        cap_enabled: checkout.cap_enabled,
        description: checkout.description,
        active: checkout.active, //default value for this field is true in database. it will be removed later. but needed for time being to make API work
      };
    });
    const saveCheckoutCounters = await sendApiRequest("stores/" + storeId + "/counters/save", checkoutRequest, "POST");
    //evaluate api response
    if (typeof saveCheckoutCounters.success !== "undefined" && saveCheckoutCounters.success === true) {
      toast("Checkout info saved successfully", { type: "success" });
      // this function will reset and fetch devices from backend to get updated data.
      discardCheckoutChanges(storeId);
      return {
        success: true,
      };
    } else {
      toast("Sorry, something went wrong", { type: "error" });
      return {
        success: false,
      };
    }
  }
};

export const discardCheckoutChanges = (storeId) => {
  reset_infrastructure_config_page_data(storeId);
};

export const checkSystemCheckoutNumber = (instoreNumber) => {
  const userStateData = store.getState().userSelections;
  let systemCoNumber = "";
  if (typeof userStateData.checkout_layout_list !== "undefined") {
    userStateData.checkout_layout_list.forEach((layoutInfo) => {
      if (layoutInfo.instore_co_number === instoreNumber) {
        systemCoNumber = layoutInfo.system_co_number;
      }
    });
  }

  return systemCoNumber;
};

export const saveCheckoutMapping = async (storeId) => {
  const userStateData = store.getState().userSelections;

  const checkoutMappingPorts =
    typeof userStateData.multiplexer_device_ports !== "undefined" ? userStateData.multiplexer_device_ports : [];

  const checkoutMappingInfo = typeof userStateData.checkout_mapping !== "undefined" ? userStateData.checkout_mapping : {};
  let mappingRequestBody = {};
  if (checkoutMappingPorts.length !== 0) {
    checkoutMappingPorts.forEach((mappingPort) => {
      let portObjs = {};
      mappingPort.device_ports.forEach((portName) => {
        portObjs = {
          ...portObjs,
          checkout_reader_id: mappingPort.checkout_reader_id,
          devices: {
            ...portObjs.devices,
            [portName.replace(": ", "_").replace(" ", "_")]:
              typeof checkoutMappingInfo[mappingPort.checkout_reader_id] !== "undefined" &&
                typeof checkoutMappingInfo[mappingPort.checkout_reader_id].devices !== "undefined" &&
                typeof checkoutMappingInfo[mappingPort.checkout_reader_id].devices[
                portName.replace(": ", "_").replace(" ", "_")
                ] !== "undefined" &&
                checkoutMappingInfo[mappingPort.checkout_reader_id].devices[portName.replace(": ", "_").replace(" ", "_")]
                  .instore_co_number !== "None"
                ? checkoutMappingInfo[mappingPort.checkout_reader_id].devices[portName.replace(": ", "_").replace(" ", "_")]
                : {
                  device_port: portName,
                  instore_co_number: 99,
                },
          },
        };
      });
      mappingRequestBody = {
        ...mappingRequestBody,
        [mappingPort.checkout_reader_id]: portObjs,
      };
    });
    // send request to save info
    const saveMapping = await sendApiRequest("stores/" + storeId + "/checkout-mapping/save", mappingRequestBody, "POST");
    //evaluate api response
    if (typeof saveMapping.success !== "undefined" && saveMapping.success === true) {
      toast("Checkout mapping saved successfully", { type: "success" });
      trackChanges(false);
      // this function will reset and fetch devices from backend to get updated data.
      discardCheckoutChanges(storeId);
      return {
        success: true,
      };
    } else {
      toast("Sorry, something went wrong", { type: "error" });
      return {
        success: false,
      };
    }
  } else {
    toast("Sorry, please provide sufficient data", { type: "error" });
    return {
      success: false,
    };
  }
};

export const addMappingEntries = () => {
  const userStateData = store.getState().userSelections;
  let mappingEntries = [];
  if (
    typeof userStateData.db_device_info !== "undefined" &&
    typeof userStateData.db_device_info.checkout_readers !== "undefined"
  ) {
    userStateData.db_device_info.checkout_readers.forEach((checkoutReader, index) => {
      let selectedMultiplexerOption =
        typeof userStateData.assigned_multiplexer["checkout_" + checkoutReader.id] !== "undefined"
          ? userStateData.assigned_multiplexer["checkout_" + checkoutReader.id]
          : [];
      let multiplexerOffsets = [];
      selectedMultiplexerOption.forEach((portValue) => {
        multiplexerOffsets = [...multiplexerOffsets, ...mappingOffsets[portValue]];
      });
      //  multiplexerOffsets = mappingOffsets[selectedMultiplexerOption];
      mappingEntries = [
        ...mappingEntries,
        {
          device_ports: [...["ANT1", "ANT2", "ANT3", "ANT4"], ...multiplexerOffsets],
          checkout_reader_ip: checkoutReader.ip_address,
          checkout_reader_id: checkoutReader.id,
        },
      ];
    });
    store.dispatch(
      updateStateData({
        multiplexer_device_ports: mappingEntries.sort((next, prev) => {
          var nextIpOctets = next.checkout_reader_ip.split(".");
          var prevIpOctets = prev.checkout_reader_ip.split(".");
          var nextIPLastOctet = parseInt(nextIpOctets[nextIpOctets.length - 1]);
          var prevIPLastOctet = parseInt(prevIpOctets[prevIpOctets.length - 1]);
          return nextIPLastOctet - prevIPLastOctet;
        }),
        multiplexer_offset_positions: mappingOffsetPositions
      })
    );

    return {
      success: true,
      mappingEntries,
    };
  } else {
    return {
      success: false,
    };
  }
};

export const fetchCheckoutMapping = async (storeId) => {
  const fetchMapping = await sendApiRequest("stores/" + storeId + "/checkout-mapping", {}, "GET");
  //evaluate api response
  if (typeof fetchMapping.success !== "undefined" && fetchMapping.success === true) {
    let assignedMultiplexers = {};
    if (typeof fetchMapping.response !== "undefined" && Object.keys(fetchMapping.response).length !== 0) {
      Object.keys(fetchMapping.response).forEach((mappingKey) => {
        assignedMultiplexers = {
          ...assignedMultiplexers,
          ["checkout_" + mappingKey]:
            typeof fetchMapping.response[mappingKey].multiplexer !== "undefined" &&
              fetchMapping.response[mappingKey].multiplexer.length !== 0
              ? fetchMapping.response[mappingKey].multiplexer
              : ["No Multiplexer"],
        };
      });
    }
    // selected checkout nums
    let selectedCheckoutNums = [];
    if (Object.keys(fetchMapping.response).length !== 0) {
      Object.values(fetchMapping.response).forEach((mappingInfo) => {
        if (typeof mappingInfo.devices !== "undefined") {
          Object.values(mappingInfo.devices).forEach((portInfo) => {
            selectedCheckoutNums.push(portInfo.instore_co_number);
          });
        }
      });
    } else {
      selectedCheckoutNums = [];
    }
    store.dispatch(
      updateStateData({
        checkout_mapping: fetchMapping.response,
        assigned_multiplexer: assignedMultiplexers,
        db_checkout_mapping: fetchMapping.response,
        selected_checkout_nums: [...selectedCheckoutNums],
      })
    );

    addMappingEntries();

    return {
      success: true,
    };
  } else {
    // toast("Sorry, something went wrong", { type: "error" });
    return {
      success: false,
    };
  }
};

export const saveInfraNote = async (noteText, storeId, note_id, type = "normal") => {
  // send request to save info
  let notesRequestBody = { notes: noteText, type: type };
  if (note_id !== "") {
    notesRequestBody = {
      ...notesRequestBody,
      id: note_id,
    };
  }
  const saveNote = await sendApiRequest("stores/" + storeId + "/notes/save", notesRequestBody, "POST");
  //evaluate api response
  if (typeof saveNote.success !== "undefined" && saveNote.success === true) {
    toast("Note saved successfully", { type: "success" });
    // this function will reset and fetch new data from backend to get updated data.
    discardCheckoutChanges(storeId);
    return {
      success: true,
    };
  } else {
    toast("Sorry, something went wrong", { type: "error" });
    return {
      success: false,
    };
  }
};

export const fetchInfraNote = async (storeId) => {
  // send request to save info
  const fetchNote = await sendApiRequest("stores/" + storeId + "/notes", {}, "GET");
  //evaluate api response
  if (typeof fetchNote.success !== "undefined" && fetchNote.success === true) {
    if (typeof fetchNote.response.notes !== "undefined") {
      store.dispatch(
        updateStateData({
          infra_note: fetchNote.response.notes,
          note_id: fetchNote.response.id,
        })
      );
    }

    return {
      success: true,
    };
  } else {
    toast("Sorry, something went wrong", { type: "error" });
    return {
      success: false,
    };
  }
};

export const fetchCyreenNote = async (storeId) => {
  // send request to save info
  const fetchNote = await sendApiRequest("stores/" + storeId + "/notes/cyreen", {}, "GET");
  //evaluate api response
  if (typeof fetchNote.success !== "undefined" && fetchNote.success === true) {
    if (typeof fetchNote.response.notes !== "undefined") {
      store.dispatch(
        updateStateData({
          infra_cyreen_note: fetchNote.response.notes,
          cyreen_note_id: fetchNote.response.id,
        })
      );
    }

    return {
      success: true,
    };
  } else {
    toast("Sorry, something went wrong", { type: "error" });
    return {
      success: false,
    };
  }
};

// to decide whether counter text will be visible on checkout layout section and confirmation popup while saving mapping details
export const checkCounterTextToShow = () => {
  const userStateData = store.getState().userSelections;
  const checkoutCounterObj =
    typeof userStateData.checkout_layout_list !== "undefined" ? userStateData.checkout_layout_list : [];
  let showtext = false;
  if (checkoutCounterObj.length !== 0) {
    checkoutCounterObj.forEach((counterObj) => {
      if (counterObj.active === true && counterObj.cap_enabled === true) {
        if (
          typeof userStateData.selected_checkout_nums !== "undefined" &&
          !userStateData.selected_checkout_nums.includes(counterObj.instore_co_number)
        )
          showtext = true;
      }
    });
  }
  return showtext;
};

export const duplicateIpCheck = async (storeId) => {
  const userStateData = store.getState().userSelections;
  // send request to save info
  const checkDuplicacy = await sendApiRequest(
    "stores/validate-ip/" + storeId,
    {
      store_ip: "10." + userStateData.store_ip_info.second_octet + "." + userStateData.store_ip_info.third_octet + ".0/24",
    },
    "POST"
  );

  //evaluate api response
  if (typeof checkDuplicacy.success !== "undefined" && checkDuplicacy.success === true) {
    if (typeof checkDuplicacy.response !== "undefined" && checkDuplicacy.response.success === false) {
      return {
        error: true,
        message: "Duplicate IP",
      };
    } else {
      return {
        error: false,
        message: "IP is valid",
      };
    }
  } else {
    return {
      error: false,
    };
  }
};

export const fetchTimezones = async () => {
  // send request to save info
  const timezones = await sendApiRequest("timezones", {}, "GET", { skipRetailerViewFilter: true });
  //evaluate api response
  if (typeof timezones.success !== "undefined" && timezones.success === true) {

    store.dispatch(
      updateStateData({
        infra_timezones: timezones.response.map((timezone) => {
          return {
            label: "(UTC " + timezone.utc_offset + ") " + timezone.name,
            id: timezone.id_timezone,
          };
        }),
      })
    );
    return {
      success: true,
    };
  } else {
    toast("Sorry, something went wrong", { type: "error" });
    return {
      success: false,
    };
  }
};

// ─── Opening & Quiet Hours — Store Details ────────────────────────────────────

export const legacyHoursToSchedule = (opening_hours, generateId) => {
  if (!opening_hours) return null;

  const weekdays = WEEKDAY_KEYS.reduce((acc, day) => {
    const times = opening_hours[day];
    const isClosed =
      !times ||
      (times[0] === "00:00" && times[1] === "00:00");
    const is24h =
      !isClosed &&
      ((times[0] === "00:05" && times[1] === "23:50") ||   // legacy format
       (times[0] === "00:00" && times[1] === "23:59"));     // new API format

    acc[day] = {
      open: !isClosed,
      is_24h: is24h,
      time_ranges:
        isClosed || is24h
          ? [{ open: "08:00", close: "20:00" }]
          : [{ open: times[0], close: times[1] }],
    };
    return acc;
  }, {});

  return {
    id: "local_" + (generateId ? generateId() : Math.floor(Math.random() * 1e8)),
    name: opening_hours.description || "Default Schedule",
    validity_start: null,
    validity_end: null,
    no_end: true,
    is_collapsed: false,
    active: true,
    same_times_all_days: false,
    same_times_is_24h: false,
    same_times_ranges: [{ open: "08:00", close: "20:00" }],
    weekdays,
  };
};

const TYPE_UI_TO_API = { "Open": "open", "Open 24 Hours": "open24", "Closed": "closed" };

// Resolves a day-keyed entry from the open_hours object regardless of whether
// the backend keys are UPPERCASE day names (MONDAY, TUESDAY, …), lowercase day
// names, or numeric strings ("1", "2", … per WEEKDAY_LOWER_TO_INT).
const getRangesForDay = (openHoursMap, dayLower) => {
  if (!openHoursMap || typeof openHoursMap !== "object") return [];
  const upper = dayLower.toUpperCase();
  if (Array.isArray(openHoursMap[upper])) return openHoursMap[upper];
  if (Array.isArray(openHoursMap[dayLower])) return openHoursMap[dayLower];
  const numKey = String(WEEKDAY_LOWER_TO_INT[dayLower]);
  if (Array.isArray(openHoursMap[numKey])) return openHoursMap[numKey];
  return [];
};

const mapRegularSchedule = (dto, idx) => {
  const weekdays = {};
  WEEKDAY_KEYS.forEach((day) => {
    const ranges = getRangesForDay(dto.open_hours, day);
    const sortedRanges = [...ranges].sort((a, b) => {
      const aStart = (a.startTime || a.start || "");
      const bStart = (b.startTime || b.start || "");
      return aStart > bStart ? 1 : -1;
    });
    const is24h =
      sortedRanges.length === 1 &&
      (sortedRanges[0].startTime || sortedRanges[0].start || "").startsWith("00:00") &&
      (sortedRanges[0].endTime || sortedRanges[0].end || "").startsWith("23:59");
    weekdays[day] = {
      open: sortedRanges.length > 0,
      is_24h: is24h,
      // Preserve a usable fallback when 24h so toggling off 24h shows a sensible default
      time_ranges: is24h
        ? [{ open: "08:00", close: "20:00" }]
        : sortedRanges.map((r) => ({
            open: (r.startTime || r.start || "").slice(0, 5),
            close: denormalizeCloseTime((r.endTime || r.end || "").slice(0, 5)),
          })),
    };
  });
  return {
    id: "api_" + (idx + 1),
    name: dto.name || "Schedule " + (idx + 1),
    validity_start: dto.valid_from || null,
    validity_end: dto.valid_to || null,
    no_end: !dto.valid_to,
    is_collapsed: false,
    // "expired" is a state the dates produce, not the saved on/off flag — reading
    // it as deactivated would silently write active: false back on the next save.
    active:
      typeof dto.active === "boolean"
        ? dto.active
        : (dto.status || "").toLowerCase() !== "inactive",
    same_times_all_days: false,
    same_times_is_24h: false,
    same_times_ranges: [{ open: "08:00", close: "20:00" }],
    weekdays,
  };
};

const mapSpecialHoursRanges = (raw, startKey, endKey) => {
  if (Array.isArray(raw)) {
    // New API format: [{startTime, endTime}] — strip seconds if present
    return raw.map((r) => ({
      [startKey]: (r.startTime || r.start || "").slice(0, 5),
      [endKey]: denormalizeCloseTime((r.endTime || r.end || "").slice(0, 5)),
    }));
  }
  if (raw && typeof raw === "object") {
    // Legacy format: {DAY: [{start, end}]}
    const dayKey = Object.keys(raw)[0];
    return dayKey
      ? (raw[dayKey] || []).map((r) => ({ [startKey]: r.start, [endKey]: denormalizeCloseTime(r.end) }))
      : [];
  }
  return [];
};

const mapSpecialHours = (dto, idx) => {
  const openRanges = mapSpecialHoursRanges(dto.open_hours, "open", "close");
  const quietRanges = mapSpecialHoursRanges(dto.quiet_hours, "start", "end");
  const is24h =
    openRanges.length === 1 &&
    openRanges[0].open === "00:00" &&
    openRanges[0].close === "00:00";
  return {
    id: dto.id != null ? dto.id : "api_" + (idx + 1),
    valid_on: dto.valid_on,
    name: dto.name,
    type: openRanges.length === 0 ? "Closed" : is24h ? "Open 24 Hours" : "Open",
    open_hours: openRanges,
    has_quiet_hours: quietRanges.length > 0,
    quiet_hours: quietRanges,
    status: dto.status,
  };
};

// Normalizes a list of time ranges from any of {startTime,endTime}/{start,end}
// shape and strips seconds (HH:mm:ss → HH:mm).
const normalizeQuietRanges = (raw) => {
  if (!Array.isArray(raw)) return [];
  return raw.map((r) => ({
    start: (r.start || r.startTime || "").slice(0, 5),
    end: denormalizeCloseTime((r.end || r.endTime || "").slice(0, 5)),
  }));
};

// Normalizes repeats_on, which may arrive as numeric indices (1=Mon … 0=Sun)
// or UPPERCASE day name strings (MONDAY, TUESDAY, …).
const normalizeRepeatsOn = (raw) => {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((entry) => {
      if (typeof entry === "number") return WEEKDAY_INT_TO_LOWER[entry];
      if (typeof entry === "string") {
        const lower = entry.toLowerCase();
        return WEEKDAY_KEYS.includes(lower) ? lower : null;
      }
      return null;
    })
    .filter(Boolean);
};

const mapQuietHours = (dto, idx) => {
  const id = dto.id != null ? dto.id : "api_" + (idx + 1);
  // API now signals "once" when repeats_on is null. Older payloads may still set dto.type === "once".
  const isOnce = dto.type === "once" || dto.repeats_on == null;
  if (isOnce) {
    return {
      id,
      type: "once",
      valid_on: dto.valid_on || dto.valid_from || null,
      time_ranges: normalizeQuietRanges(dto.quiet_hours),
      next_occurrence: dto.next_occurrence || null,
      status: dto.status,
    };
  }
  return {
    id,
    type: "weekly",
    validity_start: dto.valid_from || null,
    validity_end: dto.valid_to || null,
    no_end: !dto.valid_to,
    repeat_on: normalizeRepeatsOn(dto.repeats_on),
    time_ranges: normalizeQuietRanges(dto.quiet_hours),
    next_occurrence: dto.next_occurrence || null,
    status: dto.status,
  };
};

// Fetch all regular opening schedules for a store and store them in Redux.
// API endpoint: GET stores/{storeId}/schedule/regular
export const fetchStoreSchedules = async (storeId) => {
  const result = await sendApiRequest("stores/" + storeId + "/schedule/regular", {}, "GET");

  if (typeof result.success !== "undefined" && result.success === true) {
    store.dispatch(
      updateStateData({
        store_regular_schedules: Array.isArray(result.response)
          ? result.response.map(mapRegularSchedule)
          : [],
      })
    );
    return { success: true };
  } else {
    toast("Sorry, something went wrong", { type: "error" });
    return { success: false };
  }
};

// Transforms one wizard schedule into the API's {valid_from, valid_to, name, schedule, active} shape.
const buildRegularSchedulePayload = (schedule) => {
  const scheduleMap = {};
  WEEKDAY_KEYS.forEach((day) => {
    const dayData = schedule.weekdays?.[day] || {};
    if (!dayData.open) {
      scheduleMap[String(WEEKDAY_LOWER_TO_INT[day])] = [];
      return;
    }
    // same_times_all_days shares one set of time ranges across all open days
    if (schedule.same_times_all_days) {
      scheduleMap[String(WEEKDAY_LOWER_TO_INT[day])] = schedule.same_times_is_24h
        ? [{ start: "00:00", end: "23:59" }]
        : (schedule.same_times_ranges || []).map((r) => ({ start: r.open, end: normalizeCloseTime(r.close) }));
    } else if (dayData.is_24h) {
      scheduleMap[String(WEEKDAY_LOWER_TO_INT[day])] = [{ start: "00:00", end: "23:59" }];
    } else {
      scheduleMap[String(WEEKDAY_LOWER_TO_INT[day])] = (dayData.time_ranges || []).map((r) => ({ start: r.open, end: normalizeCloseTime(r.close) }));
    }
  });
  return {
    valid_from: schedule.validity_start,
    valid_to: schedule.no_end ? null : schedule.validity_end,
    name: schedule.name || "",
    schedule: scheduleMap,
    active: schedule.active !== false,
  };
};

// Save regular opening schedules for a store. Sends one request per schedule entry.
// silent=true suppresses the success toast (used when a parent operation already shows one).
// API endpoint: POST stores/{storeId}/schedule/regular/save
export const saveRegularSchedules = async (storeId, schedules, silent = false) => {
  const result = await sendApiRequest(
    "stores/" + storeId + "/schedule/regular/save",
    schedules.map(buildRegularSchedulePayload),
    "POST"
  );
  if (result.success !== true) {
    toast(result.response?.message || "Sorry, something went wrong", { type: "error" });
    return { success: false };
  }
  if (!silent) toast("Opening hours updated successfully.", { type: "success" });
  await fetchStoreSchedules(storeId);
  return { success: true };
};

// Fetch special opening hours for a store.
// API endpoint: GET stores/{storeId}/schedule/special
export const fetchSpecialHours = async (storeId) => {
  const result = await sendApiRequest("stores/" + storeId + "/schedule/special", {}, "GET");

  if (typeof result.success !== "undefined" && result.success === true) {
    store.dispatch(
      updateStateData({
        store_special_hours: Array.isArray(result.response)
          ? result.response.map(mapSpecialHours)
          : [],
      })
    );
    return { success: true };
  } else {
    toast("Sorry, something went wrong", { type: "error" });
    return { success: false };
  }
};

// Fetch quiet hours for a store.
// API endpoint: GET stores/{storeId}/schedule/quiet
export const fetchQuietHours = async (storeId) => {
  const result = await sendApiRequest("stores/" + storeId + "/schedule/quiet", {}, "GET");

  if (typeof result.success !== "undefined" && result.success === true) {
    store.dispatch(
      updateStateData({
        store_quiet_hours: Array.isArray(result.response)
          ? result.response.map(mapQuietHours)
          : [],
      })
    );
    return { success: true };
  } else {
    toast("Sorry, something went wrong", { type: "error" });
    return { success: false };
  }
};

// Fetch schedule overview (current open hours + upcoming specials + upcoming quiet).
// API endpoint: GET stores/{storeId}/schedule/overview
export const fetchScheduleOverview = async (storeId) => {
  const result = await sendApiRequest("stores/" + storeId + "/schedule/overview", {}, "GET");

  if (typeof result.success !== "undefined" && result.success === true) {
    store.dispatch(
      updateStateData({
        store_schedule_overview: result.response,
      })
    );
    return { success: true };
  } else {
    toast("Sorry, something went wrong", { type: "error" });
    return { success: false };
  }
};

// Bulk variant for Excel export: returns the schedule overview per store id
// without dispatching to Redux. Uses the bulk endpoint, which returns one
// overview per requested store id, in the same order as the request.
// API endpoint: POST stores/schedule-overviews  body: { store_ids: [...] }
export const fetchScheduleOverviewsBulk = async (storeIds) => {
  const ids = (storeIds || []).filter((id) => id != null);
  const result = {};
  if (ids.length === 0) return result;

  const res = await sendApiRequest("stores/schedule-overviews", { store_ids: ids }, "POST");

  if (res.success === true && Array.isArray(res.response)) {
    res.response.forEach((overview, idx) => {
      result[ids[idx]] = overview || null;
    });
  } else {
    ids.forEach((id) => {
      result[id] = null;
    });
  }
  return result;
};

const toApiTimeRanges = (ranges, openKey, closeKey) =>
  (ranges || []).map((r) => ({
    start: r[openKey] || "",
    end: r[closeKey] ? normalizeCloseTime(r[closeKey]) : "",
  }));

// Builds the request payload for the special-hours save endpoint.
const buildSpecialHoursPayload = (data, groupId) => {
  const payload = {
    valid_on: data.valid_on,
    name: data.name,
    type: TYPE_UI_TO_API[data.type] || data.type,
    open_hours: toApiTimeRanges(data.open_hours, "open", "close"),
    quiet_hours: toApiTimeRanges(data.quiet_hours, "start", "end"),
  };
  if (groupId != null) payload.id = groupId;
  return payload;
};

// API endpoint: POST stores/{storeId}/schedule/special/save
export const saveSpecialHours = async (storeId, data) => {
  const result = await sendApiRequest(
    "stores/" + storeId + "/schedule/special/save",
    buildSpecialHoursPayload(data, null),
    "POST"
  );
  if (typeof result.response !== "undefined" && result.response.success === true) {
    toast("Special Hours saved successfully.", { type: "success" });
    await fetchSpecialHours(storeId);
    return { success: true };
  } else {
    toast(result.response?.message || "Sorry, something went wrong", { type: "error" });
    return { success: false };
  }
};

// API endpoint: POST stores/{storeId}/schedule/special/save (scheduleId in body identifies the record to update)
export const updateSpecialHours = async (storeId, id, data) => {
  // Pass scheduleId only when we have a real server-side id (not a synthetic "api_X" fallback)
  const groupId = id != null && !/^api_/.test(String(id)) ? id : null;
  const result = await sendApiRequest(
    "stores/" + storeId + "/schedule/special/save",
    buildSpecialHoursPayload(data, groupId),
    "POST"
  );
  if (typeof result.response !== "undefined" && result.response.success === true) {
    toast("Special Hours updated successfully.", { type: "success" });
    await fetchSpecialHours(storeId);
    return { success: true };
  } else {
    toast(result.response?.message || "Sorry, something went wrong", { type: "error" });
    return { success: false };
  }
};

// API endpoint: POST stores/{storeId}/schedule/special/delete/{scheduleId}
// On success the backend returns the updated list, which is dispatched directly.
export const deleteSpecialHours = async (storeId, id) => {
  const result = await sendApiRequest("stores/" + storeId + "/schedule/special/delete/" + id, {}, "POST");
  if (result.success === true) {
    toast("Special Hours deleted.", { type: "success" });
    await fetchSpecialHours(storeId);
    return { success: true };
  } else {
    toast(result.response?.message || "Sorry, something went wrong", { type: "error" });
    return { success: false };
  }
};

const buildQuietHoursPayload = (data, scheduleId = null) => {
  const normalizeRange = (r) => ({ start: r.start, end: normalizeCloseTime(r.end) });
  let payload;
  if (data.type === "once") {
    const dayIndex = new Date(data.valid_on).getDay(); // 0=Sunday, 6=Saturday
    const schedule = {};
    for (let d = 0; d <= 6; d++) {
      schedule[String(d)] = d === dayIndex
        ? (data.time_ranges || []).map(normalizeRange)
        : [];
    }
    payload = {
      valid_from: data.valid_on,
      valid_to: data.valid_on,
      schedule,
      active: true,
    };
  } else {
    const schedule = {};
    (data.repeat_on || []).forEach((day) => {
      schedule[String(WEEKDAY_LOWER_TO_INT[day])] = (data.time_ranges || []).map(normalizeRange);
    });
    payload = {
      valid_from: data.validity_start,
      valid_to: data.no_end ? null : data.validity_end,
      schedule,
      active: true,
    };
  }
  if (scheduleId != null) payload.id = scheduleId;
  return payload;
};

// API endpoint: POST stores/{storeId}/schedule/quiet/save
export const saveQuietHours = async (storeId, data) => {
  const result = await sendApiRequest("stores/" + storeId + "/schedule/quiet/save", buildQuietHoursPayload(data), "POST");
  if (result.success === true) {
    toast("Quiet hours saved successfully.", { type: "success" });
    await fetchQuietHours(storeId);
    return { success: true };
  } else {
    toast("Sorry, something went wrong", { type: "error" });
    return { success: false };
  }
};

// API endpoint: POST stores/{storeId}/schedule/quiet/save (scheduleId in body identifies the record to update)
export const updateQuietHours = async (storeId, id, data) => {
  const scheduleId = id != null && !/^api_/.test(String(id)) ? id : null;
  const result = await sendApiRequest("stores/" + storeId + "/schedule/quiet/save", buildQuietHoursPayload(data, scheduleId), "POST");
  if (result.success === true) {
    toast("Quiet hours updated successfully.", { type: "success" });
    await fetchQuietHours(storeId);
    return { success: true };
  } else {
    toast("Sorry, something went wrong", { type: "error" });
    return { success: false };
  }
};

export const deleteQuietHours = async (storeId, id) => {
  const result = await sendApiRequest("stores/" + storeId + "/schedule/quiet/delete/" + id, {}, "POST");
  if (result.success === true) {
    toast("Quiet hours deleted.", { type: "success" });
    await fetchQuietHours(storeId);
    return { success: true };
  } else {
    toast(result.response?.message || "Sorry, something went wrong", { type: "error" });
    return { success: false };
  }
};